window.FLC_PEN_FINDER_VARIANT_DATA = {};
// Guangna High Gloss 1mm Acrylic Gel Pens — clean variant mapping
(function () {
  var newGuangnaHighGlossVariants = [
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Bluish Green",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "58823216005504",
      codes: ["G13", "G14", "G15", "G16", "G17", "G18", "G20", "G21", "G19", "G22", "G23", "G24"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Brown",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "58823215972736",
      codes: ["F01", "F02", "F03", "F04", "F05", "F06", "F07", "F08", "F09", "F10", "F11", "F12"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Fiery Red",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "58823216038272",
      codes: ["R01", "R02", "R03", "R04", "R05", "R06", "R07", "R08", "R09", "R10", "R11", "R12"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Fluorescent",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "58823216071040",
      codes: ["L27", "P14", "Y15", "G41", "Y17", "Z15", "Y16", "Z16", "G40", "R13", "H01", "H02"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Grass Green",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "58823216103808",
      codes: ["G01", "G02", "G03", "G04", "G05", "G06", "G07", "G08", "G09", "G10", "G11", "G12"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Grayish Cyan",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "58823216136576",
      codes: ["L13", "L14", "L15", "L16", "L17", "L18", "L19", "L20", "L21", "L22", "L23", "L24"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Grayish Green",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "58823216169344",
      codes: ["G25", "G26", "G27", "G28", "G29", "G35", "G30", "G31", "G32", "G33", "G34", "G36"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Light Skin",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "58823216202112",
      codes: ["F13", "F14", "F15", "F16", "F17", "F18", "F19", "F20", "F21", "F22", "F23", "F24"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Macaron",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "58823216234880",
      codes: ["L26", "P13", "Y14", "G37", "Z14", "Z13", "F37", "Y13", "G38", "L25", "G39", "H03"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Marine Blue",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "58823216267648",
      codes: ["L01", "L02", "L03", "L04", "L05", "L06", "L07", "L08", "L09", "L10", "L11", "L12"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Orange Yellow",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "58823216300416",
      codes: ["Y01", "Y02", "Y03", "Y04", "Y05", "Y06", "Y07", "Y08", "Y09", "Y10", "Y11", "Y12"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Peach Pink",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "58823216333184",
      codes: ["P01", "P02", "P03", "P04", "P05", "P06", "P07", "P08", "P09", "P10", "P11", "P12"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Purple Lotus",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "58823216365952",
      codes: ["Z01", "Z02", "Z03", "Z04", "Z05", "Z06", "Z07", "Z08", "Z09", "Z10", "Z11", "Z12"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Warm Skin",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "58823216398720",
      codes: ["F25", "F26", "F27", "F28", "F29", "F30", "F31", "F32", "F33", "F34", "F35", "F36"]
    }
  ];

  newGuangnaHighGlossVariants.forEach(function (product) {
    product.codes.forEach(function (code) {
      if (!window.FLC_PEN_FINDER_VARIANT_DATA[code]) {
        window.FLC_PEN_FINDER_VARIANT_DATA[code] = [];
      }
      window.FLC_PEN_FINDER_VARIANT_DATA[code].push({
        code: code,
        name: product.product + " – " + product.variant + " Variant",
        handle: product.handle,
        variantId: product.variantId,
        variant: product.variant
      });
    });
  });
})();




// ==========================================
// ENMY INK CONTROL ACRYLIC BRUSH MARKERS
// ==========================================

(function () {

  const enmyHandle = "enmy-ink-control-acrylic-brush-markers";

  const enmyVariants = [
    {
      variant: "24 Colours",
      variantId: "59953441440128",
      codes: [
        "E1", "R1", "RY1", "Y1", "G1", "B3", "V1", "O",
        "DE1", "VR1", "RY2", "G3", "G2", "B1", "V2", "BR1",
        "1", "R2", "BR2", "Y2", "BG1", "B2", "BG2", "GY1"
      ]
    },
    {
      variant: "36 Colours",
      variantId: "59953441472896",
      codes: [
        "E1", "RY3", "R3", "VR1", "Y3", "Y1", "G1", "B1",
        "B5", "E2", "R1", "VR3", "RY1", "G3", "G4", "G2",
        "B4", "B3", "R2", "DE1", "R4", "VR2", "RY2", "Y2",
        "BG2", "BG1", "B2", "1", "GY1", "BR3", "BR2", "BR1",
        "0", "V3", "V1", "V2"
      ]
    },
    {
      variant: "80 Colours",
      variantId: "59953441538432",
      codes: [
        "E4", "E1", "R5", "R2", "VR4", "VR5", "VR2", "VR3",
        "VR1", "R7", "BR6", "E2", "E3", "DE1", "DE2", "R4",
        "RY3", "R1", "R3", "R6", "Y2", "Y6", "Y5", "Y7",
        "Y1", "Y4", "Y3", "RY2", "RY1", "RY4", "G13", "G7",
        "G8", "G4", "G3", "G5", "G10", "G6", "G2", "G1",
        "B2", "BG2", "BG5", "BG1", "BG3", "BG6", "BG4", "G12",
        "G9", "G11", "B7", "B4", "B6", "B10", "B1", "B3",
        "B5", "B12", "B11", "B8", "BG7", "BV1", "V2", "BV2",
        "V5", "V1", "V3", "V4", "V7", "V6", "B9", "GY1",
        "GY2", "BR3", "BR2", "BR5", "BR4", "BR1", "1", "0"
      ]
    }
  ];

  enmyVariants.forEach(function (variantData) {

    variantData.codes.forEach(function (code) {

      if (!window.FLC_PEN_FINDER_VARIANT_DATA[code]) {
        window.FLC_PEN_FINDER_VARIANT_DATA[code] = [];
      }

      window.FLC_PEN_FINDER_VARIANT_DATA[code].push({
        code: code,
        name: "ENMY Ink Control Acrylic Brush Markers – " + variantData.variant + " Variant",
        handle: enmyHandle,
        variantId: variantData.variantId,
        variant: variantData.variant
      });

    });

  });

})();


// ==========================================================
// FIND MY PEN – NEW VARIANT PRODUCT ADDITIONS
// 111 NEW VARIANT ROWS FROM THE 125-ROW TEMPLATE
// The 14 Guangna High Gloss rows already exist in
// pen-finder-variant-data-v1.js and are intentionally excluded
// here to prevent duplicate Find My Pen results.
// Add this entire block BELOW the existing master database.
// ==========================================================

(function () {

  const newVariantProducts = [

    // Guangna 12 Acrylic Brush Markers
    {
          "product": "Guangna 12 Acrylic Brush Markers",
          "variant": "Macaron - E",
          "variantId": "58687381995904",
          "handle": "guangna-12-acrylic-brush-markers-pastels-skin-colours",
          "codes": [
                "836",
                "627",
                "732",
                "702",
                "736",
                "744",
                "821",
                "723",
                "706",
                "730",
                "646",
                "700"
          ]
    },
    {
          "product": "Guangna 12 Acrylic Brush Markers",
          "variant": "Macaron - H",
          "variantId": "58687326257536",
          "handle": "guangna-12-acrylic-brush-markers-pastels-skin-colours",
          "codes": [
                "762",
                "655",
                "729",
                "733",
                "649",
                "765",
                "635",
                "745",
                "822",
                "737",
                "648",
                "669"
          ]
    },
    {
          "product": "Guangna 12 Acrylic Brush Markers",
          "variant": "Skin Colour - A",
          "variantId": "58687326159232",
          "handle": "guangna-12-acrylic-brush-markers-pastels-skin-colours",
          "codes": [
                "719",
                "701",
                "720",
                "718",
                "717",
                "724",
                "683",
                "684",
                "802",
                "732",
                "733",
                "656"
          ]
    },
    {
          "product": "Guangna 12 Acrylic Brush Markers",
          "variant": "Skin Colour - B",
          "variantId": "58687326192000",
          "handle": "guangna-12-acrylic-brush-markers-pastels-skin-colours",
          "codes": [
                "837",
                "721",
                "703",
                "624",
                "625",
                "704",
                "872",
                "716",
                "677",
                "691",
                "761",
                "692"
          ]
    },
    {
          "product": "Guangna 12 Acrylic Brush Markers",
          "variant": "Skin Colour - C",
          "variantId": "58687326224768",
          "handle": "guangna-12-acrylic-brush-markers-pastels-skin-colours",
          "codes": [
                "630",
                "654",
                "754",
                "755",
                "756",
                "619",
                "620",
                "769",
                "779",
                "869",
                "672",
                "780"
          ]
    },
    {
          "product": "Guangna 12 Acrylic Brush Markers",
          "variant": "Skin Colour - D",
          "variantId": "58687214748032",
          "handle": "guangna-12-acrylic-brush-markers-pastels-skin-colours",
          "codes": [
                "738",
                "645",
                "731",
                "814",
                "618",
                "644",
                "757",
                "639",
                "758",
                "643",
                "708",
                "776"
          ]
    },

    // Languo 0.6mm Gel Pens
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "0.5mm Black x3",
          "variantId": "58694206685568",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "Black",
                "G1300"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "0.5mm Red x3",
          "variantId": "58694206718336",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "Red",
                "G1300"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Advanced Grey x9",
          "variantId": "58694206652800",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "GJ-211",
                "GJ-212",
                "GJ-213",
                "GJ-214",
                "GJ-215",
                "GJ-216",
                "GJ-217",
                "GJ-218",
                "GJ-219"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Black x3",
          "variantId": "58694206751104",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "Black",
                "SM-117"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Blue Style",
          "variantId": "58694206783872",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "HL-701",
                "HL-702",
                "HL-703",
                "HL-704",
                "HL-705",
                "HL-706",
                "HL-707",
                "HL-708",
                "HL-709"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Chinese Red",
          "variantId": "58694206816640",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "ZG-261",
                "ZG-262",
                "ZG-263",
                "ZG-264",
                "ZG-265",
                "ZG-266",
                "ZG-267",
                "ZG-268",
                "ZG-269"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Colour Of Skin (D0557)",
          "variantId": "58694206882176",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "FS-601",
                "FS-602",
                "FS-603",
                "FS-604",
                "FS-605",
                "FS-606",
                "FS-607",
                "FS-608",
                "FS-609"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Colour Of Skin (D0569)",
          "variantId": "58694206849408",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "FS-191",
                "FS-192",
                "FS-193",
                "FS-194",
                "FS-195",
                "FS-196",
                "FS-197",
                "FS-198",
                "FS-199"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Colourful Black",
          "variantId": "58694206914944",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "BH-151",
                "BH-152",
                "BH-153",
                "BH-154",
                "BH-155",
                "BH-156",
                "BH-157",
                "BH-158",
                "BH-159"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Dark Skin",
          "variantId": "58694206947712",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "MH-221",
                "MH-222",
                "MH-223",
                "MH-224",
                "MH-225",
                "MH-226",
                "MH-227",
                "MH-228",
                "MH-229"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Dopamine",
          "variantId": "58694206980480",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "DB-181",
                "DB-182",
                "DB-183",
                "DB-184",
                "DB-185",
                "DB-186",
                "DB-187",
                "DB-188",
                "DB-189"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Dusty Blue",
          "variantId": "58694207013248",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "YL-231",
                "YL-232",
                "YL-233",
                "YL-234",
                "YL-235",
                "YL-236",
                "YL-237",
                "YL-238",
                "YL-239"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Green Style",
          "variantId": "58694207046016",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "ZS-801",
                "ZS-802",
                "ZS-803",
                "ZS-804",
                "ZS-805",
                "ZS-806",
                "ZS-807",
                "ZS-808",
                "ZS-809"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Grey Purple",
          "variantId": "58694207078784",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "LM-251",
                "LM-252",
                "LM-253",
                "LM-254",
                "LM-255",
                "LM-256",
                "LM-257",
                "LM-258",
                "LM-259"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Highlight Metallics",
          "variantId": "58694207111552",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "JY-143",
                "JY-141",
                "SM-111"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Highlight Neons",
          "variantId": "58694207144320",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "GF-401",
                "GF-402",
                "GF-403",
                "GF-404",
                "GF-405",
                "GF-406",
                "GF-407",
                "GF-408",
                "GF-409"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Light Colours",
          "variantId": "58694207177088",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "DC-201",
                "DC-202",
                "DC-203",
                "DC-204",
                "DC-205",
                "DC-206",
                "DC-207",
                "DC-208",
                "DC-209"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Lipstick Red",
          "variantId": "58694207209856",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "CH-161",
                "CH-162",
                "CH-163",
                "CH-164",
                "CH-165",
                "CH-166",
                "CH-167",
                "CH-168",
                "CH-169"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Maillard",
          "variantId": "58694207242624",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "ML-131",
                "ML-132",
                "ML-133",
                "ML-134",
                "ML-135",
                "ML-136",
                "ML-137",
                "ML-138",
                "ML-139"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Morandi (Green Theme)",
          "variantId": "58694207275392",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "MB-101",
                "MB-102",
                "MB-103",
                "MB-104",
                "MB-105",
                "MB-106",
                "MB-107",
                "MB-108",
                "MB-109"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Morandi (Blue Theme)",
          "variantId": "58694207308160",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "MY-201",
                "MY-202",
                "MY-203",
                "MY-204",
                "MY-205",
                "MY-206",
                "MY-207",
                "MY-208",
                "MY-209"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Morandi (Brown Theme)",
          "variantId": "58694207340928",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "MF-301",
                "MF-302",
                "MF-303",
                "MF-304",
                "MF-305",
                "MF-306",
                "MF-307",
                "MF-308",
                "MF-309"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Morandi (Pink Theme)",
          "variantId": "58694207373696",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "MT-01",
                "MT-02",
                "MT-03",
                "MT-04",
                "MT-05",
                "MT-06",
                "MT-07",
                "MT-08",
                "MT-09"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Puper Style",
          "variantId": "58694207406464",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "MZ-501",
                "MZ-502",
                "MZ-503",
                "MZ-504",
                "MZ-505",
                "MZ-506",
                "MZ-507",
                "MZ-508",
                "MZ-509"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Reddish Yellow",
          "variantId": "58694207439232",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "HN-901",
                "HN-902",
                "HN-903",
                "HN-904",
                "HN-905",
                "HN-906",
                "HN-907",
                "HN-908",
                "HN-909"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Sage Green",
          "variantId": "58694207472000",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "MS-241",
                "MS-242",
                "MS-243",
                "MS-244",
                "MS-245",
                "MS-246",
                "MS-247",
                "MS-248",
                "MS-249"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Sketch x6",
          "variantId": "58694207504768",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "SM-112",
                "SM-113",
                "SM-114",
                "SM-115",
                "SM-116",
                "SM-117"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Soda Green Style",
          "variantId": "58694207537536",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "SD-271",
                "SD-272",
                "SD-273",
                "SD-274",
                "SD-275",
                "SD-276",
                "SD-277",
                "SD-278",
                "SD-279"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Sweet Pink",
          "variantId": "58694207570304",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "TF-121",
                "TF-122",
                "TF-123",
                "TF-124",
                "TF-125",
                "TF-126",
                "TF-127",
                "TF-128",
                "TF-129"
          ]
    },
    {
          "product": "Languo 0.6mm Gel Pens",
          "variant": "Warm Yellow",
          "variantId": "58694207603072",
          "handle": "languo-0-6mm-gel-pens",
          "codes": [
                "WH-171",
                "WH-172",
                "WH-173",
                "WH-174",
                "WH-175",
                "WH-176",
                "WH-177",
                "WH-178",
                "WH-179"
          ]
    },

    // Languo Acrylic Brush Markers (M720)
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Advanced Grey",
          "variantId": "59876006363520",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "AG-171",
                "AG-172",
                "AG-173",
                "AG-174",
                "AG-175",
                "AG-176",
                "AG-177",
                "AG-178",
                "AG-179"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Blue Series",
          "variantId": "59876006396288",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "BL-201",
                "BL-202",
                "BL-203",
                "BL-204",
                "BL-205",
                "BL-206",
                "BL-207",
                "BL-208",
                "BL-209"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Candy Pink",
          "variantId": "59876006429056",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "PC-233",
                "PC-235",
                "PC-237",
                "PC-238",
                "PC-239",
                "PC-240",
                "PC-242",
                "PC-243",
                "PC-244"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Cocoa Brown",
          "variantId": "59876006461824",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "AG-245",
                "AG-246",
                "AG-247",
                "AG-248",
                "AG-249",
                "AG-250",
                "AG-253",
                "AG-254",
                "AG-256"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Colour Of Skin",
          "variantId": "59876006494592",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "CS-501",
                "CS-502",
                "CS-503",
                "CS-504",
                "CS-505",
                "CS-506",
                "CS-507",
                "CS-508",
                "CS-509"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Colour Of Skin 2",
          "variantId": "59876006527360",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "CS-141",
                "CS-142",
                "CS-143",
                "CS-144",
                "CS-145",
                "CS-146",
                "CS-147",
                "CS-148",
                "CS-149"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Colourful Black",
          "variantId": "59876006560128",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "CB-901",
                "CB-902",
                "CB-903",
                "CB-904",
                "CB-905",
                "CB-906",
                "CB-907",
                "CB-908",
                "CB-909"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Dark Skin",
          "variantId": "59876006592896",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "DS-181",
                "DS-182",
                "DS-183",
                "DS-184",
                "DS-185",
                "DS-186",
                "DS-187",
                "DS-188",
                "DS-189"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Dopamine",
          "variantId": "59876006625664",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "HC-601",
                "HC-602",
                "HC-603",
                "HC-604",
                "HC-605",
                "HC-606",
                "HC-607",
                "HC-608",
                "HC-609"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Dopamine 2",
          "variantId": "59876006658432",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "HC-131",
                "HC-132",
                "HC-133",
                "HC-134",
                "HC-135",
                "HC-136",
                "HC-137",
                "HC-138",
                "HC-139"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Dusty Blue",
          "variantId": "59876006691200",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "DB-161",
                "DB-162",
                "DB-163",
                "DB-164",
                "DB-165",
                "DB-166",
                "DB-167",
                "DB-168",
                "DB-169"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Forest Green",
          "variantId": "59876006723968",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "SG-221",
                "SG-222",
                "SG-224",
                "SG-225",
                "SG-226",
                "SG-228",
                "SG-230",
                "SG-231",
                "SG-232"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Galaxy Purple",
          "variantId": "59876006756736",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "BL-257",
                "BL-259",
                "BL-260",
                "BL-261",
                "BL-264",
                "BL-265",
                "BL-266",
                "BL-267",
                "BL-268"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Gray Brown",
          "variantId": "59876006789504",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "GB-401",
                "GB-402",
                "GB-403",
                "GB-404",
                "GB-405",
                "GB-406",
                "GB-407",
                "GB-408",
                "GB-409"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Green",
          "variantId": "59876006822272",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "GR-101",
                "GR-102",
                "GR-103",
                "GR-104",
                "GR-105",
                "GR-106",
                "GR-107",
                "GR-108",
                "GR-109"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Light Colour",
          "variantId": "59876006855040",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "LC-191",
                "LC-192",
                "LC-193",
                "LC-194",
                "LC-195",
                "LC-196",
                "LC-197",
                "LC-198",
                "LC-199"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Lip Gloss Red",
          "variantId": "59876006887808",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "LC-111",
                "LC-112",
                "LC-113",
                "LC-114",
                "LC-115",
                "LC-116",
                "LC-117",
                "LC-118",
                "LC-119"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Maillard",
          "variantId": "59876006920576",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "BR-701",
                "BR-702",
                "BR-703",
                "BR-704",
                "BR-705",
                "BR-706",
                "BR-707",
                "BR-708",
                "BR-709"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Purple",
          "variantId": "59876006953344",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "PU-301",
                "PU-302",
                "PU-303",
                "PU-304",
                "PU-305",
                "PU-306",
                "PU-307",
                "PU-308",
                "PU-309"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Red Yellow",
          "variantId": "59876006986112",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "RY-01",
                "RY-02",
                "RY-03",
                "RY-04",
                "RY-05",
                "RY-06",
                "RY-07",
                "RY-08",
                "RY-09"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Sage Green",
          "variantId": "59876007018880",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "SG-151",
                "SG-152",
                "SG-153",
                "SG-154",
                "SG-155",
                "SG-156",
                "SG-157",
                "SG-158",
                "SG-159"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Sweet Pink",
          "variantId": "59876007051648",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "PC-801",
                "PC-802",
                "PC-803",
                "PC-804",
                "PC-805",
                "PC-806",
                "PC-807",
                "PC-808",
                "PC-809"
          ]
    },
    {
          "product": "Languo Acrylic Brush Markers (M720)",
          "variant": "Warm Yellow",
          "variantId": "59876007084416",
          "handle": "languo-acrylic-brush-markers-m720",
          "codes": [
                "YE-121",
                "YE-122",
                "YE-123",
                "YE-124",
                "YE-125",
                "YE-126",
                "YE-127",
                "YE-128",
                "YE-129"
          ]
    },

    // Languo Plus 1mm Acrylic Gel Painting Pens
    {
          "product": "Languo Plus 1mm Acrylic Gel Painting Pens",
          "variant": "Black & White Calligraphy",
          "variantId": "58694420660608",
          "handle": "languo-plus-1mm-acrylic-gel-painting-pens",
          "codes": [
                "Black",
                "White"
          ]
    },
    {
          "product": "Languo Plus 1mm Acrylic Gel Painting Pens",
          "variant": "Black Calligraphy",
          "variantId": "58694420595072",
          "handle": "languo-plus-1mm-acrylic-gel-painting-pens",
          "codes": [
                "Black"
          ]
    },
    {
          "product": "Languo Plus 1mm Acrylic Gel Painting Pens",
          "variant": "Classic Chinese Beauty",
          "variantId": "58694420693376",
          "handle": "languo-plus-1mm-acrylic-gel-painting-pens",
          "codes": [
                "Chinese"
          ]
    },
    {
          "product": "Languo Plus 1mm Acrylic Gel Painting Pens",
          "variant": "Classic National Beauty",
          "variantId": "58694420726144",
          "handle": "languo-plus-1mm-acrylic-gel-painting-pens",
          "codes": [
                "National"
          ]
    },
    {
          "product": "Languo Plus 1mm Acrylic Gel Painting Pens",
          "variant": "Color Of Skin 2 (P650-11)",
          "variantId": "58694420431232",
          "handle": "languo-plus-1mm-acrylic-gel-painting-pens",
          "codes": [
                "BG-191",
                "BG-192",
                "BG-193",
                "BG-196",
                "BG-197",
                "BG-199"
          ]
    },
    {
          "product": "Languo Plus 1mm Acrylic Gel Painting Pens",
          "variant": "Colour Of Skin (P650-10)",
          "variantId": "58694420398464",
          "handle": "languo-plus-1mm-acrylic-gel-painting-pens",
          "codes": [
                "BG-601",
                "BG-602",
                "BG-603",
                "BG-604",
                "BG-606",
                "BG-609"
          ]
    },
    {
          "product": "Languo Plus 1mm Acrylic Gel Painting Pens",
          "variant": "Colourful Black",
          "variantId": "58694420529536",
          "handle": "languo-plus-1mm-acrylic-gel-painting-pens",
          "codes": [
                "BG-151",
                "BG-152",
                "BG-154",
                "BG-155",
                "BG-157",
                "BG-158"
          ]
    },
    {
          "product": "Languo Plus 1mm Acrylic Gel Painting Pens",
          "variant": "Dopamine",
          "variantId": "58694420562304",
          "handle": "languo-plus-1mm-acrylic-gel-painting-pens",
          "codes": [
                "BG-181",
                "BG-183",
                "BG-184",
                "BG-185",
                "BG-187",
                "BG-189"
          ]
    },
    {
          "product": "Languo Plus 1mm Acrylic Gel Painting Pens",
          "variant": "Maillard",
          "variantId": "58694420496768",
          "handle": "languo-plus-1mm-acrylic-gel-painting-pens",
          "codes": [
                "BG-132",
                "BG-133",
                "BG-135",
                "BG-136",
                "BG-137",
                "BG-139"
          ]
    },
    {
          "product": "Languo Plus 1mm Acrylic Gel Painting Pens",
          "variant": "Monet Purple",
          "variantId": "58694420332928",
          "handle": "languo-plus-1mm-acrylic-gel-painting-pens",
          "codes": [
                "BG-501",
                "BG-502",
                "BG-503",
                "BG-505",
                "BG-506",
                "BG-508"
          ]
    },
    {
          "product": "Languo Plus 1mm Acrylic Gel Painting Pens",
          "variant": "Natural Forest",
          "variantId": "58694420201856",
          "handle": "languo-plus-1mm-acrylic-gel-painting-pens",
          "codes": [
                "BG-801",
                "BG-803",
                "BG-804",
                "BG-805",
                "BG-807",
                "BG-809"
          ]
    },
    {
          "product": "Languo Plus 1mm Acrylic Gel Painting Pens",
          "variant": "Nordic Blue",
          "variantId": "58694420300160",
          "handle": "languo-plus-1mm-acrylic-gel-painting-pens",
          "codes": [
                "BG-02",
                "BG-202",
                "BG-102",
                "BG-201",
                "BG-301",
                "BG-101"
          ]
    },
    {
          "product": "Languo Plus 1mm Acrylic Gel Painting Pens",
          "variant": "Red Lipstick",
          "variantId": "58694420169088",
          "handle": "languo-plus-1mm-acrylic-gel-painting-pens",
          "codes": [
                "BG-161",
                "BG-162",
                "BG-164",
                "BG-166",
                "BG-167",
                "BG-169"
          ]
    },
    {
          "product": "Languo Plus 1mm Acrylic Gel Painting Pens",
          "variant": "Reddish Yellow",
          "variantId": "58694420136320",
          "handle": "languo-plus-1mm-acrylic-gel-painting-pens",
          "codes": [
                "BG-902",
                "BG-903",
                "BG-904",
                "BG-906",
                "BG-907",
                "BG-909"
          ]
    },
    {
          "product": "Languo Plus 1mm Acrylic Gel Painting Pens",
          "variant": "Sea Salt Blue",
          "variantId": "58694420267392",
          "handle": "languo-plus-1mm-acrylic-gel-painting-pens",
          "codes": [
                "BG-701",
                "BG-702",
                "BG-704",
                "BG-705",
                "BG-707",
                "BG-709"
          ]
    },
    {
          "product": "Languo Plus 1mm Acrylic Gel Painting Pens",
          "variant": "Sketch",
          "variantId": "58694420464000",
          "handle": "languo-plus-1mm-acrylic-gel-painting-pens",
          "codes": [
                "BG-111",
                "BG-112",
                "BG-113",
                "BG-114",
                "BG-116",
                "BG-117"
          ]
    },
    {
          "product": "Languo Plus 1mm Acrylic Gel Painting Pens",
          "variant": "Sweet Pink",
          "variantId": "58694420365696",
          "handle": "languo-plus-1mm-acrylic-gel-painting-pens",
          "codes": [
                "BG-121",
                "BG-122",
                "BG-124",
                "BG-125",
                "BG-126",
                "BG-128"
          ]
    },
    {
          "product": "Languo Plus 1mm Acrylic Gel Painting Pens",
          "variant": "Warm Yellow",
          "variantId": "58694420103552",
          "handle": "languo-plus-1mm-acrylic-gel-painting-pens",
          "codes": [
                "BG-171",
                "BG-173",
                "BG-175",
                "BG-176",
                "BG-177",
                "BG-178"
          ]
    },
    {
          "product": "Languo Plus 1mm Acrylic Gel Painting Pens",
          "variant": "White Calligraphy",
          "variantId": "58694420627840",
          "handle": "languo-plus-1mm-acrylic-gel-painting-pens",
          "codes": [
                "White"
          ]
    },
    {
          "product": "Languo Plus 1mm Acrylic Gel Painting Pens",
          "variant": "The Wizard of Oz",
          "variantId": "58694420234624",
          "handle": "languo-plus-1mm-acrylic-gel-painting-pens",
          "codes": [
                "BG-03",
                "BG-204",
                "BG-203",
                "BG-304",
                "BG-303",
                "BG-104"
          ]
    },

    // Languo Retractable 0.7mm Acrylic Gel Pens
    {
          "product": "Languo Retractable 0.7mm Acrylic Gel Pens",
          "variant": "1 - Warm Yellow",
          "variantId": "58749797302656",
          "handle": "languo-retractable-0-7mm-acrylic-gel-pens",
          "codes": [
                "BG-171",
                "BG-173",
                "BG-175",
                "BG-176",
                "BG-177",
                "BG-178"
          ]
    },
    {
          "product": "Languo Retractable 0.7mm Acrylic Gel Pens",
          "variant": "10 - Colour of Skin",
          "variantId": "58749797597568",
          "handle": "languo-retractable-0-7mm-acrylic-gel-pens",
          "codes": [
                "BG-601",
                "BG-602",
                "BG-603",
                "BG-604",
                "BG-606",
                "BG-609"
          ]
    },
    {
          "product": "Languo Retractable 0.7mm Acrylic Gel Pens",
          "variant": "11 - Colour of Skin 2",
          "variantId": "58749797630336",
          "handle": "languo-retractable-0-7mm-acrylic-gel-pens",
          "codes": [
                "BG-191",
                "BG-192",
                "BG-193",
                "BG-196",
                "BG-197",
                "BG-199"
          ]
    },
    {
          "product": "Languo Retractable 0.7mm Acrylic Gel Pens",
          "variant": "12 - Sketch",
          "variantId": "58749797663104",
          "handle": "languo-retractable-0-7mm-acrylic-gel-pens",
          "codes": [
                "BG-111",
                "BG-112",
                "BG-113",
                "BG-114",
                "BG-116",
                "BG-117"
          ]
    },
    {
          "product": "Languo Retractable 0.7mm Acrylic Gel Pens",
          "variant": "13 - Maillard",
          "variantId": "58749797695872",
          "handle": "languo-retractable-0-7mm-acrylic-gel-pens",
          "codes": [
                "BG-132",
                "BG-133",
                "BG-135",
                "BG-136",
                "BG-137",
                "BG-139"
          ]
    },
    {
          "product": "Languo Retractable 0.7mm Acrylic Gel Pens",
          "variant": "14 - Colourful Black",
          "variantId": "58749797728640",
          "handle": "languo-retractable-0-7mm-acrylic-gel-pens",
          "codes": [
                "BG-151",
                "BG-152",
                "BG-154",
                "BG-155",
                "BG-157",
                "BG-158"
          ]
    },
    {
          "product": "Languo Retractable 0.7mm Acrylic Gel Pens",
          "variant": "15 - Dopamine",
          "variantId": "58749797761408",
          "handle": "languo-retractable-0-7mm-acrylic-gel-pens",
          "codes": [
                "BG-181",
                "BG-183",
                "BG-184",
                "BG-185",
                "BG-187",
                "BG-189"
          ]
    },
    {
          "product": "Languo Retractable 0.7mm Acrylic Gel Pens",
          "variant": "2 - Vitality & Warmth",
          "variantId": "58749797335424",
          "handle": "languo-retractable-0-7mm-acrylic-gel-pens",
          "codes": [
                "BG-902",
                "BG-903",
                "BG-904",
                "BG-906",
                "BG-907",
                "BG-909"
          ]
    },
    {
          "product": "Languo Retractable 0.7mm Acrylic Gel Pens",
          "variant": "3 - Lipstick Red",
          "variantId": "58749797368192",
          "handle": "languo-retractable-0-7mm-acrylic-gel-pens",
          "codes": [
                "BG-161",
                "BG-162",
                "BG-164",
                "BG-166",
                "BG-167",
                "BG-169"
          ]
    },
    {
          "product": "Languo Retractable 0.7mm Acrylic Gel Pens",
          "variant": "4 - Natural Forest",
          "variantId": "58749797400960",
          "handle": "languo-retractable-0-7mm-acrylic-gel-pens",
          "codes": [
                "BG-801",
                "BG-803",
                "BG-804",
                "BG-805",
                "BG-807",
                "BG-809"
          ]
    },
    {
          "product": "Languo Retractable 0.7mm Acrylic Gel Pens",
          "variant": "5 - Wizard of Oz",
          "variantId": "58749797433728",
          "handle": "languo-retractable-0-7mm-acrylic-gel-pens",
          "codes": [
                "BG-03",
                "BG-204",
                "BG-203",
                "BG-304",
                "BG-303",
                "BG-104"
          ]
    },
    {
          "product": "Languo Retractable 0.7mm Acrylic Gel Pens",
          "variant": "6 - Sea Salt Blue",
          "variantId": "58749797466496",
          "handle": "languo-retractable-0-7mm-acrylic-gel-pens",
          "codes": [
                "BG-701",
                "BG-702",
                "BG-704",
                "BG-705",
                "BG-707",
                "BG-709"
          ]
    },
    {
          "product": "Languo Retractable 0.7mm Acrylic Gel Pens",
          "variant": "7 - Nordic Blue",
          "variantId": "58749797499264",
          "handle": "languo-retractable-0-7mm-acrylic-gel-pens",
          "codes": [
                "BG-02",
                "BG-202",
                "BG-102",
                "BG-201",
                "BG-301",
                "BG-101"
          ]
    },
    {
          "product": "Languo Retractable 0.7mm Acrylic Gel Pens",
          "variant": "8 - Monet Purple",
          "variantId": "58749797532032",
          "handle": "languo-retractable-0-7mm-acrylic-gel-pens",
          "codes": [
                "BG-501",
                "BG-502",
                "BG-503",
                "BG-505",
                "BG-506",
                "BG-508"
          ]
    },
    {
          "product": "Languo Retractable 0.7mm Acrylic Gel Pens",
          "variant": "9 - Sweet Pink",
          "variantId": "58749797564800",
          "handle": "languo-retractable-0-7mm-acrylic-gel-pens",
          "codes": [
                "BG-121",
                "BG-122",
                "BG-124",
                "BG-125",
                "BG-126",
                "BG-128"
          ]
    },

    // Rosymeng 10 Acrylic Gel Pens - Colouring Cats
    {
          "product": "Rosymeng 10 Acrylic Gel Pens - Colouring Cats",
          "variant": "10 Packs of 10 - Assorted colours",
          "variantId": "59949940507008",
          "handle": "rosymeng-10-acrylic-gel-pens-colouring-cats",
          "codes": [
                "67",
                "58",
                "66",
                "65",
                "94",
                "3",
                "27",
                "55",
                "80",
                "15",
                "6",
                "10",
                "1",
                "17",
                "8",
                "7",
                "34",
                "77",
                "26",
                "24",
                "100",
                "96",
                "60",
                "71",
                "69",
                "70",
                "11",
                "59",
                "98",
                "12",
                "86",
                "51",
                "48",
                "37",
                "38",
                "73",
                "20",
                "85",
                "50",
                "76",
                "97",
                "64",
                "92",
                "63",
                "87",
                "52",
                "91",
                "74",
                "99",
                "72",
                "32",
                "31",
                "19",
                "42",
                "21",
                "43",
                "14",
                "53",
                "79",
                "78",
                "93",
                "90",
                "89",
                "88",
                "2",
                "25",
                "75",
                "61",
                "62",
                "13",
                "9",
                "68",
                "47",
                "16",
                "46",
                "41",
                "29",
                "28",
                "4",
                "40",
                "57",
                "30",
                "35",
                "22",
                "56",
                "44",
                "5",
                "18",
                "84",
                "83",
                "95",
                "82",
                "54",
                "81",
                "39",
                "36",
                "45",
                "33",
                "23",
                "49"
          ]
    },
    {
          "product": "Rosymeng 10 Acrylic Gel Pens - Colouring Cats",
          "variant": "Blue Cat",
          "variantId": "58715005124992",
          "handle": "rosymeng-10-acrylic-gel-pens-colouring-cats",
          "codes": [
                "67",
                "58",
                "66",
                "65",
                "94",
                "3",
                "27",
                "55",
                "80",
                "15"
          ]
    },
    {
          "product": "Rosymeng 10 Acrylic Gel Pens - Colouring Cats",
          "variant": "Dopamine Cat",
          "variantId": "58715005059456",
          "handle": "rosymeng-10-acrylic-gel-pens-colouring-cats",
          "codes": [
                "6",
                "10",
                "1",
                "17",
                "8",
                "7",
                "34",
                "77",
                "26",
                "24"
          ]
    },
    {
          "product": "Rosymeng 10 Acrylic Gel Pens - Colouring Cats",
          "variant": "Gardener Cat",
          "variantId": "58715004895616",
          "handle": "rosymeng-10-acrylic-gel-pens-colouring-cats",
          "codes": [
                "103",
                "113",
                "140",
                "119",
                "139",
                "108",
                "138",
                "102",
                "114",
                "116"
          ]
    },
    {
          "product": "Rosymeng 10 Acrylic Gel Pens - Colouring Cats",
          "variant": "Grey Cat",
          "variantId": "58715004928384",
          "handle": "rosymeng-10-acrylic-gel-pens-colouring-cats",
          "codes": [
                "100",
                "96",
                "60",
                "71",
                "69",
                "70",
                "11",
                "59",
                "98",
                "12"
          ]
    },
    {
          "product": "Rosymeng 10 Acrylic Gel Pens - Colouring Cats",
          "variant": "Guitar Cat",
          "variantId": "58715005288832",
          "handle": "rosymeng-10-acrylic-gel-pens-colouring-cats",
          "codes": [
                "86",
                "51",
                "48",
                "37",
                "38",
                "73",
                "20",
                "85",
                "50",
                "76"
          ]
    },
    {
          "product": "Rosymeng 10 Acrylic Gel Pens - Colouring Cats",
          "variant": "Kung Fu Cat",
          "variantId": "58715004993920",
          "handle": "rosymeng-10-acrylic-gel-pens-colouring-cats",
          "codes": [
                "97",
                "64",
                "92",
                "63",
                "87",
                "52",
                "91",
                "74",
                "99",
                "72"
          ]
    },
    {
          "product": "Rosymeng 10 Acrylic Gel Pens - Colouring Cats",
          "variant": "Magician Cat",
          "variantId": "58715004961152",
          "handle": "rosymeng-10-acrylic-gel-pens-colouring-cats",
          "codes": [
                "151",
                "152",
                "153",
                "160",
                "159",
                "158",
                "157",
                "154",
                "107",
                "156"
          ]
    },
    {
          "product": "Rosymeng 10 Acrylic Gel Pens - Colouring Cats",
          "variant": "Motorcycle Cat",
          "variantId": "58715005223296",
          "handle": "rosymeng-10-acrylic-gel-pens-colouring-cats",
          "codes": [
                "32",
                "31",
                "19",
                "42",
                "21",
                "43",
                "14",
                "53",
                "79",
                "78"
          ]
    },
    {
          "product": "Rosymeng 10 Acrylic Gel Pens - Colouring Cats",
          "variant": "Orange Cat",
          "variantId": "58715005026688",
          "handle": "rosymeng-10-acrylic-gel-pens-colouring-cats",
          "codes": [
                "93",
                "90",
                "89",
                "88",
                "2",
                "25",
                "75",
                "61",
                "62",
                "13"
          ]
    },
    {
          "product": "Rosymeng 10 Acrylic Gel Pens - Colouring Cats",
          "variant": "Painter Cat",
          "variantId": "58715004862848",
          "handle": "rosymeng-10-acrylic-gel-pens-colouring-cats",
          "codes": [
                "133",
                "141",
                "109",
                "132",
                "111",
                "131",
                "130",
                "112",
                "134",
                "101"
          ]
    },
    {
          "product": "Rosymeng 10 Acrylic Gel Pens - Colouring Cats",
          "variant": "Pastry Chef Cat",
          "variantId": "58715005092224",
          "handle": "rosymeng-10-acrylic-gel-pens-colouring-cats",
          "codes": [
                "145",
                "147",
                "146",
                "148",
                "149",
                "150",
                "144",
                "120",
                "121",
                "143"
          ]
    },
    {
          "product": "Rosymeng 10 Acrylic Gel Pens - Colouring Cats",
          "variant": "Pilot Cat",
          "variantId": "58715005190528",
          "handle": "rosymeng-10-acrylic-gel-pens-colouring-cats",
          "codes": [
                "128",
                "127",
                "110",
                "115",
                "122",
                "117",
                "104",
                "118",
                "106",
                "155"
          ]
    },
    {
          "product": "Rosymeng 10 Acrylic Gel Pens - Colouring Cats",
          "variant": "Pink Cat",
          "variantId": "58715004830080",
          "handle": "rosymeng-10-acrylic-gel-pens-colouring-cats",
          "codes": [
                "9",
                "68",
                "47",
                "16",
                "46",
                "41",
                "29",
                "28",
                "4",
                "40"
          ]
    },
    {
          "product": "Rosymeng 10 Acrylic Gel Pens - Colouring Cats",
          "variant": "Purple Cat",
          "variantId": "58715005157760",
          "handle": "rosymeng-10-acrylic-gel-pens-colouring-cats",
          "codes": [
                "57",
                "30",
                "35",
                "22",
                "56",
                "44",
                "5",
                "18",
                "84",
                "83"
          ]
    },
    {
          "product": "Rosymeng 10 Acrylic Gel Pens - Colouring Cats",
          "variant": "Singer Cat",
          "variantId": "58715004797312",
          "handle": "rosymeng-10-acrylic-gel-pens-colouring-cats",
          "codes": [
                "95",
                "82",
                "54",
                "81",
                "39",
                "36",
                "45",
                "33",
                "23",
                "49"
          ]
    },
    {
          "product": "Rosymeng 10 Acrylic Gel Pens - Colouring Cats",
          "variant": "Travel Cat",
          "variantId": "58715005256064",
          "handle": "rosymeng-10-acrylic-gel-pens-colouring-cats",
          "codes": [
                "135",
                "123",
                "124",
                "126",
                "125",
                "137",
                "136",
                "105",
                "129",
                "142"
          ]
    }

  ];

  newVariantProducts.forEach(function (product) {
    product.codes.forEach(function (code) {
      if (!window.FLC_PEN_FINDER_VARIANT_DATA[code]) {
        window.FLC_PEN_FINDER_VARIANT_DATA[code] = [];
      }

      window.FLC_PEN_FINDER_VARIANT_DATA[code].push({
        code: code,
        name: product.product + " – " + product.variant + " Variant",
        handle: product.handle,
        variantId: product.variantId,
        variant: product.variant
      });
    });
  });

})();
// ==========================================================
// NEW VARIANT PRODUCT ADDITION
// Languo Pro Acrylic Brush Markers (M730)
// ==========================================================

(function () {

  const newVariantProducts = [

    {
      "product": "Languo Pro Acrylic Brush Markers (M730)",
      "variant": "Dark Skin",
      "variantId": "60011101913472",
      "handle": "languo-pro-acrylic-brush-markers-m730",
      "codes": [
        "DS-181","DS-182","DS-183","DS-184","DS-185",
        "DS-186","DS-187","DS-188","DS-189"
      ]
    },

    {
      "product": "Languo Pro Acrylic Brush Markers (M730)",
      "variant": "Light Colours",
      "variantId": "60011101946240",
      "handle": "languo-pro-acrylic-brush-markers-m730",
      "codes": [
        "LC-191","LC-192","LC-193","LC-194","LC-195",
        "LC-196","LC-197","LC-198","LC-199"
      ]
    },

    {
      "product": "Languo Pro Acrylic Brush Markers (M730)",
      "variant": "Colour Of Skin",
      "variantId": "60011101979008",
      "handle": "languo-pro-acrylic-brush-markers-m730",
      "codes": [
        "CS-501","CS-502","CS-503","CS-504","CS-505",
        "CS-506","CS-507","CS-508","CS-509"
      ]
    }

  ];

  newVariantProducts.forEach(function (product) {
    product.codes.forEach(function (code) {
      if (!window.FLC_PEN_FINDER_VARIANT_DATA[code]) {
        window.FLC_PEN_FINDER_VARIANT_DATA[code] = [];
      }

      window.FLC_PEN_FINDER_VARIANT_DATA[code].push({
        code: code,
        name: product.product + " – " + product.variant + " Variant",
        handle: product.handle,
        variantId: product.variantId,
        variant: product.variant
      });
    });
  });

})();
// Guangna High Gloss 1mm Acrylic Gel Pens – New Variants
(function () {
  var newGuangnaVariants = [
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Golden Tangerine Glow",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "59979046781312",
      codes: ["Y18", "Y19", "Y20", "Y21", "Y22", "Y23", "Y24", "Y25", "Y26", "Y27", "Y28", "Y29"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Spring Bamboo Green",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "59979049533824",
      codes: ["G42", "G43", "G44", "G45", "G46", "G47", "G48", "G49", "G50", "G51", "G52", "G53"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Misty Deep Blue",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "59979049730432",
      codes: ["L28", "L29", "L30", "L31", "L32", "L33", "L34", "L35", "L36", "L37", "L38", "L39"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Natural Soft Glow",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "59979052777856",
      codes: ["L44", "F74", "F75", "P15", "P16", "L45", "G62", "G63", "L46", "Z29", "F76", "G64"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Cloudy Twilight Grey",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "59979053400448",
      codes: ["H04", "H05", "H06", "H07", "H08", "H09", "H10", "H11", "H12", "H13", "H14", "H15"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Clay Oat Earth",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "59979057332608",
      codes: ["F62", "F63", "F64", "F65", "F66", "F67", "F68", "F69", "F70", "F71", "F72", "F73"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Pine & Sea Teal",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "59979058446720",
      codes: ["G54", "G55", "G56", "G57", "G58", "G59", "L40", "L41", "L42", "L43", "G60", "G61"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Twilight Lilac Purple",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "59979060478336",
      codes: ["Z17", "Z18", "Z19", "Z20", "Z21", "Z22", "Z23", "Z24", "Z25", "Z26", "Z27", "Z28"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Autumn Forest Brown",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "59979064115584",
      codes: ["F38", "F39", "F40", "F41", "F42", "F43", "F44", "F45", "F46", "F47", "F48", "F49"]
    },
    {
      product: "Guangna High Gloss 1mm Acrylic Gel Pens",
      variant: "Vermillion Terracotta",
      handle: "guangna-high-gloss-1mm-acrylic-gel-pens",
      variantId: "59979065524608",
      codes: ["F50", "F51", "F52", "F53", "F54", "F55", "F56", "F57", "F58", "F59", "F60", "F61"]
    }
  ];

  newGuangnaVariants.forEach(function (product) {
    product.codes.forEach(function (code) {
      if (!window.FLC_PEN_FINDER_VARIANT_DATA[code]) {
        window.FLC_PEN_FINDER_VARIANT_DATA[code] = [];
      }

      window.FLC_PEN_FINDER_VARIANT_DATA[code].push({
        code: code,
        name: product.product + " – " + product.variant + " Variant",
        handle: product.handle,
        variantId: product.variantId,
        variant: product.variant
      });
    });
  });
})();
// Languo 1mm 3D Plus Acrylic Pens – New Variants
(function () {
  var new3DVariants = [
    {
      product: "Languo 1mm 3D Plus Acrylic Pens",
      variant: "30 - Vibrant Red",
      handle: "languo-1mm-3d-plus-acrylic-pens",
      variantId: "60029173727616",
      codes: ["BG-168", "BG-907", "BG-906", "BG-163", "BG-162", "BG-167"]
    },
    {
      product: "Languo 1mm 3D Plus Acrylic Pens",
      variant: "31 - Warm Yellow",
      handle: "languo-1mm-3d-plus-acrylic-pens",
      variantId: "60029173760384",
      codes: ["BG-176", "BG-903", "BG-902", "BG-901", "BG-178", "BG-177"]
    },
    {
      product: "Languo 1mm 3D Plus Acrylic Pens",
      variant: "32 - Natural Forest",
      handle: "languo-1mm-3d-plus-acrylic-pens",
      variantId: "60029173793152",
      codes: ["BG-802", "BG-804", "BG-805", "BG-806", "BG-808", "BG-104"]
    },
    {
      product: "Languo 1mm 3D Plus Acrylic Pens",
      variant: "33 - Sea Salt Blue",
      handle: "languo-1mm-3d-plus-acrylic-pens",
      variantId: "60029173825920",
      codes: ["BG-703", "BG-702", "BG-704", "BG-706", "BG-709", "BG-158"]
    },
    {
      product: "Languo 1mm 3D Plus Acrylic Pens",
      variant: "34 - Monet Purple",
      handle: "languo-1mm-3d-plus-acrylic-pens",
      variantId: "60029173858688",
      codes: ["BG-505", "BG-504", "BG-501", "BG-509", "BG-508", "BG-506"]
    },
    {
      product: "Languo 1mm 3D Plus Acrylic Pens",
      variant: "35 - Sweet Pink",
      handle: "languo-1mm-3d-plus-acrylic-pens",
      variantId: "60029173891456",
      codes: ["BG-128", "BG-126", "BG-125", "BG-124", "BG-122", "BG-121"]
    },
    {
      product: "Languo 1mm 3D Plus Acrylic Pens",
      variant: "36 - Colour of Skin",
      handle: "languo-1mm-3d-plus-acrylic-pens",
      variantId: "60029173924224",
      codes: ["BG-603", "BG-606", "BG-607", "BG-608", "BG-609", "BG-131"]
    },
    {
      product: "Languo 1mm 3D Plus Acrylic Pens",
      variant: "37 - Milk & Coffee",
      handle: "languo-1mm-3d-plus-acrylic-pens",
      variantId: "60029173956992",
      codes: ["BG-111", "BG-133", "BG-136", "BG-138", "BG-117", "BG-114"]
    },
    {
      product: "Languo 1mm 3D Plus Acrylic Pens",
      variant: "38 - Dopamine",
      handle: "languo-1mm-3d-plus-acrylic-pens",
      variantId: "60029173989760",
      codes: ["BG-188", "BG-181", "BG-183", "BG-184", "BG-185", "BG-189"]
    }
  ];

  new3DVariants.forEach(function (product) {
    product.codes.forEach(function (code) {
      if (!window.FLC_PEN_FINDER_VARIANT_DATA[code]) {
        window.FLC_PEN_FINDER_VARIANT_DATA[code] = [];
      }

      window.FLC_PEN_FINDER_VARIANT_DATA[code].push({
        code: code,
        name: product.product + " – " + product.variant + " Variant",
        handle: product.handle,
        variantId: product.variantId,
        variant: product.variant
      });
    });
  });
})();
// ==========================================================
// FIND MY PEN – LANGUO SHINY PLUS 1MM VARIANT ADDITIONS
// 12 NEW VARIANT ROWS
// ==========================================================

(function () {

  const newVariantProducts = [

    {
      "product": "Languo Shiny Plus Acrylic Gel Pens - 1mm",
      "variant": "Glitter Eyeshadow (P600-25)",
      "variantId": "60069932401024",
      "handle": "languo-shiny-plus-acrylic-gel-pens-1mm",
      "codes": [
        "SG-01",
        "SG-02",
        "SG-03",
        "SG-04",
        "SG-05",
        "SG-06"
      ]
    },

    {
      "product": "Languo Shiny Plus Acrylic Gel Pens - 1mm",
      "variant": "Colourful Contact Lenses (P600-26)",
      "variantId": "60069932433792",
      "handle": "languo-shiny-plus-acrylic-gel-pens-1mm",
      "codes": [
        "SG-11",
        "SG-12",
        "SG-13",
        "SG-14",
        "SG-15",
        "SG-16"
      ]
    },

    {
      "product": "Languo Shiny Plus Acrylic Gel Pens - 1mm",
      "variant": "Lip Gloss (P600-27)",
      "variantId": "60069932532096",
      "handle": "languo-shiny-plus-acrylic-gel-pens-1mm",
      "codes": [
        "SG-21",
        "SG-22",
        "SG-23",
        "SG-24",
        "SG-25",
        "SG-26"
      ]
    },

    {
      "product": "Languo Shiny Plus Acrylic Gel Pens - 1mm",
      "variant": "Magical Girl (P600-28)",
      "variantId": "60069932564864",
      "handle": "languo-shiny-plus-acrylic-gel-pens-1mm",
      "codes": [
        "SG-31",
        "SG-32",
        "SG-33",
        "SG-34",
        "SG-35",
        "SG-36"
      ]
    },

    {
      "product": "Languo Shiny Plus Acrylic Gel Pens - 1mm",
      "variant": "Ocean Blue (P600-45)",
      "variantId": "60069932597632",
      "handle": "languo-shiny-plus-acrylic-gel-pens-1mm",
      "codes": [
        "SG-41",
        "SG-42",
        "SG-43",
        "SG-44",
        "SG-45",
        "SG-46"
      ]
    },

    {
      "product": "Languo Shiny Plus Acrylic Gel Pens - 1mm",
      "variant": "Mint Smoothie (P600-46)",
      "variantId": "60069932630400",
      "handle": "languo-shiny-plus-acrylic-gel-pens-1mm",
      "codes": [
        "SG-51",
        "SG-52",
        "SG-53",
        "SG-54",
        "SG-55",
        "SG-56"
      ]
    },

    {
      "product": "Languo Shiny Plus Acrylic Gel Pens - 1mm",
      "variant": "Misty Forest (P600-47)",
      "variantId": "60069932663168",
      "handle": "languo-shiny-plus-acrylic-gel-pens-1mm",
      "codes": [
        "SG-61",
        "SG-62",
        "SG-63",
        "SG-64",
        "SG-65",
        "SG-66"
      ]
    },

    {
      "product": "Languo Shiny Plus Acrylic Gel Pens - 1mm",
      "variant": "Gilded Earth (P600-48)",
      "variantId": "60069932695936",
      "handle": "languo-shiny-plus-acrylic-gel-pens-1mm",
      "codes": [
        "SG-71",
        "SG-72",
        "SG-73",
        "SG-74",
        "SG-75",
        "SG-76"
      ]
    },

    {
      "product": "Languo Shiny Plus Acrylic Gel Pens - 1mm",
      "variant": "Mermaid Princess (P600-49)",
      "variantId": "60069932728704",
      "handle": "languo-shiny-plus-acrylic-gel-pens-1mm",
      "codes": [
        "SG-81",
        "SG-82",
        "SG-83",
        "SG-84",
        "SG-85",
        "SG-86"
      ]
    },

    {
      "product": "Languo Shiny Plus Acrylic Gel Pens - 1mm",
      "variant": "Morandi Series (P600-50)",
      "variantId": "60069932761472",
      "handle": "languo-shiny-plus-acrylic-gel-pens-1mm",
      "codes": [
        "SG-91",
        "SG-92",
        "SG-93",
        "SG-94",
        "SG-95",
        "SG-96"
      ]
    },

    {
      "product": "Languo Shiny Plus Acrylic Gel Pens - 1mm",
      "variant": "Galaxy Purple (P600-51)",
      "variantId": "60069932794240",
      "handle": "languo-shiny-plus-acrylic-gel-pens-1mm",
      "codes": [
        "SG-101",
        "SG-102",
        "SG-103",
        "SG-104",
        "SG-105",
        "SG-106"
      ]
    },

    {
      "product": "Languo Shiny Plus Acrylic Gel Pens - 1mm",
      "variant": "Macaron Series (P600-52)",
      "variantId": "60069932827008",
      "handle": "languo-shiny-plus-acrylic-gel-pens-1mm",
      "codes": [
        "SG-111",
        "SG-112",
        "SG-113",
        "SG-114",
        "SG-115",
        "SG-116"
      ]
    }

  ];

  newVariantProducts.forEach(function (product) {
    product.codes.forEach(function (code) {
      if (!window.FLC_PEN_FINDER_VARIANT_DATA[code]) {
        window.FLC_PEN_FINDER_VARIANT_DATA[code] = [];
      }

      window.FLC_PEN_FINDER_VARIANT_DATA[code].push({
        code: code,
        name: product.product + " – " + product.variant + " Variant",
        handle: product.handle,
        variantId: product.variantId,
        variant: product.variant
      });
    });
  });

})();
/* =========================================================
   LANGUO M720 ACRYLIC BRUSH MARKERS – NEW VARIANTS
   ========================================================= */

(function () {
  window.FLC_PEN_FINDER_VARIANT_DATA =
    window.FLC_PEN_FINDER_VARIANT_DATA || {};

  const m720Product = "Languo M720 Acrylic Brush Markers";
  const m720Handle = "languo-m720-acrylic-brush-markers";

  const m720Variants = [
    {
      code: "M720-51",
      variant: "Black - M720-51",
      variantId: "60072439906688"
    },
    {
      code: "M720-50",
      variant: "White - M720-50",
      variantId: "60072439939456"
    },
    {
      code: "M720-49",
      variant: "Gold - M720-49",
      variantId: "60072439972224"
    },
    {
      code: "M720-48",
      variant: "Silver - M720-48",
      variantId: "60072440004992"
    }
  ];

  m720Variants.forEach(function (item) {
    window.FLC_PEN_FINDER_VARIANT_DATA[item.code] =
      window.FLC_PEN_FINDER_VARIANT_DATA[item.code] || [];

    window.FLC_PEN_FINDER_VARIANT_DATA[item.code].push({
      code: item.code,
      name: m720Product + " – " + item.variant + " Variant",
      handle: m720Handle,
      variantId: item.variantId,
      variant: item.variant
    });
  });

})();
// Mostly Non-Variant Updates — generated from Mostly Non Variant Updates.xlsx
(function () {
  var newProducts = [
    {
      product: "Languo 0.6mm - 168 Colour Painting Gel Pen Set",
      variant: null,
      variantId: null,
      handle: "languo-168-colour-painting-gel-pen-set",
      codes: ["MT-01", "MT-02", "MT-03", "MT-04", "MT-05", "MT-06", "MT-07", "MT-08", "MT-09", "MB-101", "MB-102", "MB-103", "MB-104", "MY-201", "MY-202", "MY-203", "MY-204", "MY-205", "MY-206", "MY-207", "MY-208", "MY-209", "MF-301", "MF-302", "MF-303", "MF-304", "FS-191", "FS-192", "FS-193", "FS-194", "FS-195", "FS-196", "FS-197", "FS-198", "FS-199", "FS-601", "FS-602", "FS-603", "FS-604", "JY-143", "JY-141", "SM-111", "SM-112", "SM-113", "SM-114", "SM-115", "SM-116", "SM-117", "DB-181", "DB-182", "DB-183", "DB-184", "GF-401", "GF-402", "GF-403", "GF-404", "GF-405", "GF-406", "GF-407", "GF-408", "GF-409", "TF-121", "TF-122", "TF-123", "TF-124", "WH-171", "WH-172", "WH-173", "WH-174", "WH-175", "WH-176", "WH-177", "WH-178", "WH-179", "BH-151", "BH-152", "BH-153", "BH-154", "MB-105", "MB-106", "MB-107", "MB-108", "MB-109", "ZS-801", "ZS-802", "ZS-803", "ZS-804", "ZS-805", "ZS-806", "ZS-807", "ZS-808", "ZS-809", "MF-305", "MF-306", "MF-307", "MF-308", "MF-309", "ML-131", "ML-132", "ML-133", "ML-134", "ML-135", "ML-136", "ML-137", "ML-138", "ML-139", "FS-605", "FS-606", "FS-607", "FS-608", "FS-609", "MZ-501", "MZ-502", "MZ-503", "MZ-504", "MZ-505", "MZ-506", "MZ-507", "MZ-508", "MZ-509", "DB-185", "DB-186", "DB-187", "DB-188", "DB-189", "HN-901", "HN-902", "HN-903", "HN-904", "HN-905", "HN-906", "HN-907", "HN-908", "HN-909", "TF-125", "TF-126", "TF-127", "TF-128", "TF-129", "CH-161", "CH-162", "CH-163", "CH-164", "CH-165", "CH-166", "CH-167", "CH-168", "CH-169", "BH-155", "BH-156", "BH-157", "BH-158", "BH-159", "HL-701", "HL-702", "HL-703", "HL-704", "HL-705", "HL-706", "HL-707", "HL-708", "HL-709"]
    },
    {
      product: "Languo 0.6mm - 252 Colour Painting Gel Pen Set",
      variant: null,
      variantId: null,
      handle: "languo-252-0-6-gel-pen-set",
      codes: ["DC-201", "DC-202", "DC-203", "DC-204", "DC-205", "DC-206", "DC-207", "DC-208", "DC-209", "FS-601", "FS-602", "FS-603", "FS-604", "FS-605", "FS-606", "FS-607", "FS-608", "FS-609", "CH-161", "CH-162", "CH-163", "CH-164", "CH-165", "CH-166", "CH-167", "CH-168", "CH-169", "LM-251", "LM-252", "LM-253", "LM-254", "LM-255", "LM-256", "LM-257", "LM-258", "LM-259", "ML-131", "ML-132", "ML-133", "ML-134", "ML-135", "ML-136", "ML-137", "ML-138", "ML-139", "HN-901", "HN-902", "HN-903", "HN-904", "HN-905", "HN-906", "HN-907", "HN-908", "HN-909", "WH-171", "WH-172", "WH-173", "WH-174", "WH-175", "WH-176", "WH-177", "WH-178", "WH-179", "MS-241", "MS-242", "MS-243", "MS-244", "MS-245", "MS-246", "MS-247", "MS-248", "MS-249", "HL-701", "HL-702", "HL-703", "HL-704", "HL-705", "HL-706", "HL-707", "HL-708", "HL-709", "DB-181", "DB-182", "DB-183", "DB-184", "DB-185", "DB-186", "DB-187", "DB-188", "DB-189", "MY-201", "MY-202", "MY-203", "MY-204", "MY-205", "MY-206", "MY-207", "MY-208", "MY-209", "MB-101", "MB-102", "MB-103", "MB-104", "MB-105", "MB-106", "MB-107", "MB-108", "MB-109", "BH-151", "BH-152", "BH-153", "BH-154", "BH-155", "BH-156", "BH-157", "BH-158", "BH-159", "GJ-211", "GJ-212", "GJ-213", "GJ-214", "GJ-215", "GJ-216", "GJ-217", "GJ-218", "GJ-219", "FS-191", "FS-192", "FS-193", "FS-194", "FS-195", "FS-196", "FS-197", "FS-198", "FS-199", "TF-121", "TF-122", "TF-123", "TF-124", "TF-125", "TF-126", "TF-127", "TF-128", "TF-129", "MZ-501", "MZ-502", "MZ-503", "MZ-504", "MZ-505", "MZ-506", "MZ-507", "MZ-508", "MZ-509", "MH-221", "MH-222", "MH-223", "MH-224", "MH-225", "MH-226", "MH-227", "MH-228", "MH-229", "ZG-261", "ZG-262", "ZG-263", "ZG-264", "ZG-265", "ZG-266", "ZG-267", "ZG-268", "ZG-269", "SD-271", "SD-272", "SD-273", "SD-274", "SD-275", "SD-276", "SD-277", "SD-278", "SD-279", "ZS-801", "ZS-802", "ZS-803", "ZS-804", "ZS-805", "ZS-806", "ZS-807", "ZS-808", "ZS-809", "YL-231", "YL-232", "YL-233", "YL-234", "YL-235", "YL-236", "YL-237", "YL-238", "YL-239", "GF-401", "GF-402", "GF-403", "GF-404", "GF-405", "GF-406", "GF-407", "GF-408", "GF-409", "MT-01", "MT-02", "MT-03", "MT-04", "MT-05", "MT-06", "MT-07", "MT-08", "MT-09", "MF-301", "MF-302", "MF-303", "MF-304", "MF-305", "MF-306", "MF-307", "MF-308", "MF-309", "JY-143", "JY-141", "SM-111", "SM-112", "SM-113", "SM-114", "SM-115", "SM-116", "SM-117"]
    },
    {
      product: "Languo 0.6mm - 99 Colour Painting Gel Pen Set",
      variant: null,
      variantId: null,
      handle: "languo-99-colour-painting-gel-pen-set",
      codes: ["HN-901", "HN-902", "HN-903", "HN-904", "HN-905", "HN-906", "HN-907", "HN-908", "HN-909", "ZS-801", "ZS-802", "ZS-803", "ZS-804", "ZS-805", "ZS-806", "ZS-807", "ZS-808", "ZS-809", "HL-701", "HL-702", "HL-703", "HL-704", "HL-705", "HL-706", "HL-707", "HL-708", "HL-709", "MZ-501", "MZ-502", "MZ-503", "MZ-504", "MZ-505", "MZ-506", "MZ-507", "MZ-508", "MZ-509", "SM-111", "JY-141", "JY-143", "SM-112", "SM-113", "SM-114", "SM-115", "SM-116", "SM-117", "FS-601", "FS-602", "FS-603", "FS-604", "FS-605", "FS-606", "FS-607", "FS-608", "FS-609", "TF-121", "TF-122", "TF-123", "TF-124", "TF-125", "TF-126", "TF-127", "TF-128", "TF-129", "GF-401", "GF-402", "GF-403", "GF-404", "GF-405", "GF-406", "GF-407", "GF-408", "GF-409", "ML-131", "ML-132", "ML-133", "ML-134", "ML-135", "ML-136", "ML-137", "ML-138", "ML-139", "BH-151", "BH-152", "BH-153", "BH-154", "BH-155", "BH-156", "BH-157", "BH-158", "BH-159", "CH-161", "CH-162", "CH-163", "CH-164", "CH-165", "CH-166", "CH-167", "CH-168", "CH-169"]
    },
    {
      product: "Languo Acrylic Marker Set (M720)  – 60 Colours",
      variant: null,
      variantId: null,
      handle: "languo-acrylic-marker-set-m720-60-colours",
      codes: ["RY-07", "RY-06", "YE-126", "RY-03", "RY-02", "RY-01", "GR-104", "GR-106", "GR-109", "BL-209", "BL-206", "BL-204", "GB-401", "GB-403", "GB-405", "BR-706", "BR-702", "CS-503", "PC-802", "PU-308", "PU-302", "PU-306", "PU-304", "BL-202", "CS-501", "CS-506", "CS-507", "CS-509", "CS-508", "GR-101", "GR-103", "GR-108", "BL-205", "BL-208", "PU-305", "CB-906", "CS-143", "BL-201", "BL-203", "HC-603", "GR-105", "CB-902", "CB-908", "GB-404", "RY-09", "RY-05", "PC-807", "HC-139", "YE-129", "YE-125", "YE-127", "HC-608", "CB-905", "CB-904", "CB-909", "HC-609", "LC-119", "LC-116", "LC-118", "LC-112."]
    },
    {
      product: "Languo Acrylic Marker Set (M720) -  48 Colours",
      variant: null,
      variantId: null,
      handle: "languo-acrylic-marker-set-m720-48-colours",
      codes: ["RY-07", "RY-06", "YE-126", "RY-03", "RY-02", "RY-01", "GR-104", "GR-106", "GR-109", "BL-209", "BL-206", "BL-204", "GB-401", "GB-403", "GB-405", "BR-706", "BR-702", "CS-503", "PC-802", "PU-308", "PU-302", "PU-306", "PU-304", "BL-202", "CS-501", "CS-506", "CS-507", "CS-509", "CS-508", "GR-101", "GR-103", "GR-108", "BL-205", "BL-208", "PU-305", "CB-906", "CS-143", "BL-201", "BL-203", "HC-603", "GR-105", "CB-902", "CB-908", "GB-404", "RY-09", "RY-05", "PC-807", "HC-139."]
    },
    {
      product: "Languo Acrylic Marker Set (M720) - 288 Colours",
      variant: null,
      variantId: null,
      handle: "languo-acrylic-marker-set-m720-288-colours",
      codes: ["GB-401", "GB-403", "PU-302", "PC-802", "PU-301", "HC-609", "BR-704", "GB-402", "PC-814", "YE-136", "PC-816", "CB-907", "DB-163", "DB-169", "RY-10", "BR-713", "DS-184", "DB-1611", "AG-171", "PC-817", "BR-702", "GB-404", "PU-304", "HC-139", "LC-116", "HC-131", "CS-149", "GR-102", "LC-117", "HC-606", "GB-407", "CB-910", "DB-164", "DB-167", "RY-12", "BR-714", "DS-189", "AG-176", "AG-172", "PC-818", "BR-706", "GB-405", "PU-305", "PU-308", "LC-118", "GR-107", "RY-08", "CB-901", "LC-115", "CS-511", "GB-411", "SG-159", "DB-165", "DB-168", "RY-11", "BR-715", "DS-188", "YE-1212", "AG-173", "PU-319", "CB-906", "CB-902", "CB-908", "PC-807", "LC-112", "CB-903", "BR-709", "PC-806", "HC-601", "YE-135", "CS-148", "SG-158", "GR-114", "BL-214", "RY-13", "BR-708", "DS-187", "YE-1211", "DB-1610", "BL-215", "RY-09", "GR-109", "BL-209", "PU-306", "LC-114", "BL-207", "BR-707", "PU-303", "CS-146", "YE-134", "BR-703", "SG-157", "DB-166", "BL-213", "RY-14", "GB-412", "DS-183", "YE-1210", "DB-1612", "PU-320", "RY-07", "GR-108", "BL-208", "CS-509", "LC-113", "PC-809", "GB-406", "PU-307", "PC-801", "YE-123", "BR-711", "SG-154", "GR-115", "BL-212", "PC-808", "PU-315", "DS-182", "AG-179", "GR-1010", "PU-318", "RY-06", "GR-106", "BL-206", "CS-508", "RY-04", "CB-904", "HC-135", "PC-804", "PC-810", "HC-602", "GB-408", "GR-112", "GR-113", "BL-211", "PC-815", "PU-314", "RY-15", "AG-178", "GR-1013", "PU-321", "RY-05", "GR-105", "BL-205", "CS-507", "YE-125", "CB-909", "YE-128", "HC-607", "PU-310", "YE-132", "BR-712", "GR-111", "SG-156", "BL-210", "PC-813", "HC-605", "DS-185", "AG-177", "AG-175", "PU-317", "YE-126", "GR-104", "BL-204", "CS-506", "YE-127", "CB-905", "YE-124", "HC-136", "CS-144", "YE-130", "GB-409", "HC-132", "SG-155", "HC-604", "PC-812", "PU-312", "DS-186", "LC-1110", "AG-174", "PU-316", "RY-03", "HC-603", "BL-203", "CS-143", "HC-608", "PC-805", "YE-122", "CS-147", "CS-502", "YE-131", "GB-410", "HC-133", "SG-153", "HC-138", "PC-803", "HC-137", "DS-181", "LC-199", "GR-1011", "LC-195", "RY-02", "GR-103", "BL-202", "CS-503", "YE-129", "LC-119", "YE-121", "LC-111", "CS-505", "CS-510", "CS-504", "YE-133", "SG-152", "DB-162", "PC-811", "PU-313", "LC-197", "LC-198", "GR-1012", "LC-194", "RY-01", "GR-101", "BL-201", "CS-501", "HC-134", "BR-705", "CS-141", "CS-145", "BR-701", "CS-142", "BR-710", "GR-110", "SG-151", "DB-161", "PU-309", "PU-311", "LC-196", "LC-191", "LC-192", "LC-193", "SG-221", "SG-222", "SG-223", "SG-224", "SG-225", "SG-226", "SG-227", "SG-228", "SG-229", "SG-230", "SG-231", "SG-232", "AG-256", "AG-255", "AG-254", "AG-253", "AG-252", "AG-251", "AG-250", "AG-249", "PC-233", "PC-234", "PC-235", "PC-236", "PC-237", "PC-238", "PC-239", "PC-240", "PC-241", "PC-242", "PC-243", "PC-244", "AG-248", "AG-247", "AG-246", "AG-245", "BL-257", "BL-258", "BL-259", "BL-260", "BL-261", "BL-262", "BL-263", "BL-264", "BL-265", "BL-266", "BL-267", "BL-268"]
    },
    {
      product: "Languo Acrylic Marker Set (M720) - 96 Colours",
      variant: null,
      variantId: null,
      handle: "languo-acrylic-marker-set-m720-96-colours",
      codes: ["RY-01", "RY-02", "RY-03", "YE-126", "RY-05", "RY-06", "RY-07", "RY-09", "CB-906", "BR-708", "BR-702", "GB-401", "GR-101", "GR-103", "HC-603", "GR-104", "GR-105", "GR-106", "GR-108", "GR-109", "CB-902", "GB-405", "GB-404", "GB-403", "BL-201", "BL-202", "BL-203", "BL-204", "BL-205", "BL-206", "BL-208", "BL-209", "CB-908", "PU-305", "PU-304", "PU-302", "CS-501", "CS-503", "CS-143", "CS-506", "CS-507", "CS-508", "CS-509", "PU-306", "PC-807", "PU-308", "HC-139", "PC-802", "HC-134", "YE-129", "HC-608", "YE-127", "YE-125", "RY-04", "LC-113", "LC-114", "LC-112", "LC-118", "LC-116", "PU-301", "BR-705", "LC-119", "PC-805", "CB-905", "CB-909", "CB-904", "PC-809", "BL-207", "CB-903", "GR-107", "HC-131", "HC-609", "CS-141", "YE-121", "YE-122", "YE-124", "YE-128", "HC-135", "GB-406", "BR-707", "BR-709", "RY-08", "CS-149", "BR-704", "CS-145", "LC-111", "CS-147", "HC-136", "HC-607", "PC-804", "PU-307", "PU-303", "PC-806", "CB-901", "GR-102", "GB-402."]
    },
    {
      product: "Languo Acrylic Marker Set (M720) – 24 Colours",
      variant: null,
      variantId: null,
      handle: "languo-acrylic-marker-set-m720-24-colours",
      codes: ["RY-07", "RY-06", "YE-126", "RY-03", "RY-02", "RY-01", "GR-104", "GR-106", "GR-109", "BL-209", "BL-206", "BL-204", "GB-401", "GB-403", "GB-405", "BR-706", "BR-702", "CS-503", "PC-802", "PU-308", "PU-302", "PU-306", "PU-304", "BL-202."]
    },
    {
      product: "Languo Acrylic Marker Set (M720) – 36 Colours",
      variant: null,
      variantId: null,
      handle: "languo-acrylic-marker-set-m720-36-colours",
      codes: ["RY-07", "RY-06", "YE-126", "RY-03", "RY-02", "RY-01", "GR-104", "GR-106", "GR-109", "BL-209", "BL-206", "BL-204", "GB-401", "GB-403", "GB-405", "BR-706", "BR-702", "CS-503", "PC-802", "PU-308", "PU-302", "PU-306", "PU-304", "BL-202", "CS-501", "CS-506", "CS-507", "CS-509", "CS-508", "GR-101", "GR-103", "GR-108", "BL-205", "BL-208", "PU-305", "CB-906."]
    },
    {
      product: "144 Colour Gel Plus Acrylic Painting Gel Pen Set",
      variant: null,
      variantId: null,
      handle: "lg-1-plus-set-144",
      codes: ["BG-902", "BG-903", "BG-904", "BG-906", "BG-907", "BG-909", "BG-801", "BG-803", "BG-804", "BG-805", "BG-807", "BG-809", "BG-701", "BG-702", "BG-704", "BG-705", "BG-707", "BG-709", "BG-501", "BG-502", "BG-503", "BG-505", "BG-506", "BG-508", "BG-601", "BG-602", "BG-603", "BG-604", "BG-606", "BG-609", "BG-111", "BG-112", "BG-113", "BG-114", "BG-116", "BG-117", "BG-121", "BG-122", "BG-124", "BG-125", "BG-126", "BG-128", "BG-161", "BG-162", "BG-164", "BG-166", "BG-167", "BG-169", "BG-132", "BG-133", "BG-135", "BG-136", "BG-137", "BG-139", "BG-171", "BG-173", "BG-175", "BG-176", "BG-177", "BG-178", "BG-181", "BG-183", "BG-184", "BG-185", "BG-187", "BG-189", "BG-151", "BG-152", "BG-154", "BG-155", "BG-157", "BG-158", "BG-191", "BG-192", "BG-193", "BG-196", "BG-197", "BG-199", "BG-03", "BG-204", "BG-205", "BG-304", "BG-305", "BG-104", "BG-02", "BG-202", "BG-102", "BG-201", "BG-301", "BG-101", "BG-402", "BG-403", "BG-404", "BG-405", "BG-407", "BG-409", "BG-201", "BG-202", "BG-203", "BG-205", "BG-206", "BG-209", "BG-211", "BG-213", "BG-214", "BG-215", "BG-217", "BG-219", "BG-221", "BG-222", "BG-225", "BG-226", "BG-227", "BG-229", "BG-232", "BG-233", "BG-234", "BG-236", "BG-237", "BG-238", "BG-241", "BG-242", "BG-243", "BG-245", "BG-248", "BG-249", "BG-251", "BG-252", "BG-256", "BG-257", "BG-258", "BG-259", "BG-261", "BG-262", "BG-263", "BG-265", "BG-267", "BG-269", "BG-271", "BG-272", "BG-273", "BG-275", "BG-276", "BG-278."]
    },
    {
      product: "36 Colour Gel Plus Acrylic Painting Gel Pen Set",
      variant: null,
      variantId: null,
      handle: "lg-1-plus-set-36",
      codes: ["BG-902", "BG-903", "BG-904", "BG-906", "BG-907", "BG-909", "BG-801", "BG-803", "BG-804", "BG-805", "BG-807", "BG-809", "BG-701", "BG-702", "BG-704", "BG-705", "BG-707", "BG-709", "BG-501", "BG-502", "BG-503", "BG-505", "BG-506", "BG-508", "BG-601", "BG-602", "BG-603", "BG-604", "BG-606", "BG-609", "BG-111", "BG-112", "BG-113", "BG-114", "BG-116 and BG-117."]
    },
    {
      product: "Languo Plus 1mm - 54 Colour Gel Plus Acrylic Painting Gel Pen Set",
      variant: null,
      variantId: null,
      handle: "languo-plus-1mm-54-colour-gel-plus-acrylic-painting-gel-pen-set",
      codes: ["BG-902", "BG-903", "BG-904", "BG-906", "BG-907", "BG-909", "BG-801", "BG-803", "BG-804", "BG-805", "BG-807", "BG-809", "BG-701", "BG-702", "BG-704", "BG-705", "BG-707", "BG-709", "BG-501", "BG-502", "BG-503", "BG-505", "BG-506", "BG-508", "BG-601", "BG-602", "BG-603", "BG-604", "BG-606", "BG-609", "BG-111", "BG-112", "BG-113", "BG-114", "BG-116", "BG-117", "BG-121", "BG-122", "BG-124", "BG-125", "BG-126", "BG-128", "BG-161", "BG-162", "BG-164", "BG-166", "BG-167", "BG-169", "BG-132", "BG-133", "BG-135", "BG-136", "BG-137 and BG-139."]
    },
    {
      product: "Languo Plus 1mm - 72 Colour Gel Plus Acrylic Painting Gel Pen Set",
      variant: null,
      variantId: null,
      handle: "languo-plus-1mm-72-colour-gel-plus-acrylic-painting-gel-pen-set",
      codes: ["BG-902", "BG-903", "BG-904", "BG-906", "BG-907", "BG-909", "BG-801", "BG-803", "BG-804", "BG-805", "BG-807", "BG-809", "BG-701", "BG-702", "BG-704", "BG-705", "BG-707", "BG-709", "BG-501", "BG-502", "BG-503", "BG-505", "BG-506", "BG-508", "BG-601", "BG-602", "BG-603", "BG-604", "BG-606", "BG-609", "BG-111", "BG-112", "BG-113", "BG-114", "BG-116", "BG-117", "BG-121", "BG-122", "BG-124", "BG-125", "BG-126", "BG-128", "BG-161", "BG-162", "BG-164", "BG-166", "BG-167", "BG-169", "BG-132", "BG-133", "BG-135", "BG-136", "BG-137", "BG-139", "BG-171", "BG-173", "BG-175", "BG-176", "BG-177", "BG-178", "BG-181", "BG-183", "BG-184", "BG-185", "BG-187", "BG-189", "BG-151", "BG-152", "BG-154", "BG-155", "BG-157 and BG-158."]
    },
    {
      product: "Languo Plus 1mm - 90 Colour Gel Plus Acrylic Painting Gel Pen Set",
      variant: null,
      variantId: null,
      handle: "languo-plus-1mm-90-colour-gel-plus-acrylic-painting-gel-pen-set",
      codes: ["BG-902", "BG-903", "BG-904", "BG-906", "BG-907", "BG-909", "BG-801", "BG-803", "BG-804", "BG-805", "BG-807", "BG-809", "BG-701", "BG-702", "BG-704", "BG-705", "BG-707", "BG-709", "BG-501", "BG-502", "BG-503", "BG-505", "BG-506", "BG-508", "BG-601", "BG-602", "BG-603", "BG-604", "BG-606", "BG-609", "BG-111", "BG-112", "BG-113", "BG-114", "BG-116", "BG-117", "BG-121", "BG-122", "BG-124", "BG-125", "BG-126", "BG-128", "BG-161", "BG-162", "BG-164", "BG-166", "BG-167", "BG-169", "BG-132", "BG-133", "BG-135", "BG-136", "BG-137", "BG-139", "BG-171", "BG-173", "BG-175", "BG-176", "BG-177", "BG-178", "BG-181", "BG-183", "BG-184", "BG-185", "BG-187", "BG-189", "BG-151", "BG-152", "BG-154", "BG-155", "BG-157", "BG-158", "BG-191", "BG-192", "BG-193", "BG-196", "BG-197", "BG-199", "BG-03", "BG-204", "BG-203", "BG-304", "BG-303", "BG-104", "BG-02", "BG-202", "BG-102", "BG-201", "BG-301 and BG-101"]
    },
    {
      product: "Languo × Qimiart Plus 1mm – 216 Colour Gel Pen Set",
      variant: null,
      variantId: null,
      handle: "216-colour-gel-plus-acrylic-painting-gel-pen-set",
      codes: ["BG-902", "BG-903", "BG-904", "BG-906", "BG-907", "BG-909", "BG-801", "BG-803", "BG-804", "BG-805", "BG-807", "BG-809", "BG-701", "BG-702", "BG-704", "BG-705", "BG-707", "BG-709", "BG-501", "BG-502", "BG-503", "BG-505", "BG-506", "BG-508", "BG-601", "BG-602", "BG-603", "BG-604", "BG-606", "BG-609", "BG-111", "BG-112", "BG-113", "BG-114", "BG-116", "BG-117", "BG-121", "BG-122", "BG-124", "BG-125", "BG-126", "BG-128", "BG-161", "BG-162", "BG-164", "BG-166", "BG-167", "BG-169", "BG-132", "BG-133", "BG-135", "BG-136", "BG-137", "BG-139", "BG-171", "BG-173", "BG-175", "BG-176", "BG-177", "BG-178", "BG-181", "BG-183", "BG-184", "BG-185", "BG-187", "BG-189", "BG-151", "BG-152", "BG-154", "BG-155", "BG-157", "BG-158", "BG-191", "BG-192", "BG-193", "BG-196", "BG-197", "BG-199", "BG-03", "BG-204", "BG-205", "BG-304", "BG-303", "BG-104", "BG-02", "BG-202", "BG-102", "BG-201", "BG-301", "BG-101", "BG-402", "BG-403", "BG-404", "BG-405", "BG-407", "BG-409", "BG-201", "BG-202", "BG-203", "BG-205", "BG-206", "BG-209", "BG-211", "BG-213", "BG-214", "BG-215", "BG-217", "BG-219", "BG-221", "BG-222", "BG-225", "BG-226", "BG-227", "BG-229", "BG-232", "BG-233", "BG-234", "BG-236", "BG-237", "BG-238", "BG-241", "BG-242", "BG-243", "BG-245", "BG-248", "BG-249", "BG-251", "BG-252", "BG-256", "BG-257", "BG-258", "BG-259", "BG-261", "BG-262", "BG-263", "BG-265", "BG-267", "BG-269", "BG-271", "BG-272", "BG-273", "BG-275", "BG-276", "BG-278", "SG-01", "SG-02", "SG-03", "SG-04", "SG-05", "SG-06", "SG-81", "SG-82", "SG-83", "SG-84", "SG-85", "SG-86", "SG-111", "SG-112", "SG-113", "SG-114", "SG-115", "SG-116", "SG-71", "SG-72", "SG-73", "SG-74", "SG-75", "SG-76", "SG-61", "SG-62", "SG-63", "SG-64", "SG-65", "SG-66", "SG-51", "SG-52", "SG-53", "SG-54", "SG-55", "SG-56", "SG-41", "SG-42", "SG-43", "SG-44", "SG-45", "SG-46", "SG-101", "SG-102", "SG-103", "SG-104", "SG-105", "SG-106", "SG-21", "SG-22", "SG-23", "SG-24", "SG-25", "SG-26", "SG-91", "SG-92", "SG-93", "SG-94", "SG-95", "SG-96", "SG-11", "SG-12", "SG-13", "SG-14", "SG-15", "SG-16", "SG-31", "SG-32", "SG-33", "SG-34", "SG-35 and SG-36"]
    },
    {
      product: "Languo Acrylic Pro Marker Set (M730) - 288 Colours",
      variant: null,
      variantId: null,
      handle: "languo-acrylic-pro-marker-set-m730-288-colours",
      codes: ["GB-401", "GB-403", "PU-302", "PC-802", "PU-301", "HC-609", "BR-704", "GB-402", "PC-814", "YE-136", "PC-816", "CB-907", "DB-163", "DB-169", "RY-10", "BR-713", "DS-184", "DB-1611", "AG-171", "PC-817", "BR-702", "GB-404", "PU-304", "HC-139", "LC-116", "HC-131", "CS-149", "GR-102", "LC-117", "HC-606", "GB-407", "CB-910", "DB-164", "DB-167", "RY-12", "BR-714", "DS-189", "AG-176", "AG-172", "PC-818", "BR-706", "GB-405", "PU-305", "PU-308", "LC-118", "GR-107", "RY-08", "CB-901", "LC-115", "CS-511", "GB-411", "SG-159", "DB-165", "DB-168", "RY-11", "BR-715", "DS-188", "YE-1212", "AG-173", "PU-319", "CB-906", "CB-902", "CB-908", "PC-807", "LC-112", "CB-903", "BR-709", "PC-806", "HC-601", "YE-135", "CS-148", "SG-158", "GR-114", "BL-214", "RY-13", "BR-708", "DS-187", "YE-1211", "DB-1610", "BL-215", "RY-09", "GR-109", "BL-209", "PU-306", "LC-114", "BL-207", "BR-707", "PU-303", "CS-146", "YE-134", "BR-703", "SG-157", "DB-166", "BL-213", "RY-14", "GB-412", "DS-183", "YE-1210", "DB-1612", "PU-320", "RY-07", "GR-108", "BL-208", "CS-509", "LC-113", "PC-809", "GB-406", "PU-307", "PC-801", "YE-123", "BR-711", "SG-154", "GR-115", "BL-212", "PC-808", "PU-315", "DS-182", "AG-179", "GR-1010", "PU-318", "RY-06", "GR-106", "BL-206", "CS-508", "RY-04", "CB-904", "HC-135", "PC-804", "PC-810", "HC-602", "GB-408", "GR-112", "GR-113", "BL-211", "PC-815", "PU-314", "RY-15", "AG-178", "GR-1013", "PU-321", "RY-05", "GR-105", "BL-205", "CS-507", "YE-125", "CB-909", "YE-128", "HC-607", "PU-310", "YE-132", "BR-712", "GR-111", "SG-156", "BL-210", "PC-813", "HC-605", "DS-185", "AG-177", "AG-175", "PU-317", "YE-126", "GR-104", "BL-204", "CS-506", "YE-127", "CB-905", "YE-124", "HC-136", "CS-144", "YE-130", "GB-409", "HC-132", "SG-155", "HC-604", "PC-812", "PU-312", "DS-186", "LC-1110", "AG-174", "PU-316", "RY-03", "HC-603", "BL-203", "CS-143", "HC-608", "PC-805", "YE-122", "CS-147", "CS-502", "YE-131", "GB-410", "HC-133", "SG-153", "HC-138", "PC-803", "HC-137", "DS-181", "LC-199", "GR-1011", "LC-195", "RY-02", "GR-103", "BL-202", "CS-503", "YE-129", "LC-119", "YE-121", "LC-111", "CS-505", "CS-510", "CS-504", "YE-133", "SG-152", "DB-162", "PC-811", "PU-313", "LC-197", "LC-198", "GR-1012", "LC-194", "RY-01", "GR-101", "BL-201", "CS-501", "HC-134", "BR-705", "CS-141", "CS-145", "BR-701", "CS-142", "BR-710", "GR-110", "SG-151", "DB-161", "PU-309", "PU-311", "LC-196", "LC-191", "LC-192", "LC-193", "SG-221", "SG-222", "SG-223", "SG-224", "SG-225", "SG-226", "SG-227", "SG-228", "SG-229", "SG-230", "SG-231", "SG-232", "AG-256", "AG-255", "AG-254", "AG-253", "AG-252", "AG-251", "AG-250", "AG-249", "PC-233", "PC-234", "PC-235", "PC-236", "PC-237", "PC-238", "PC-239", "PC-240", "PC-241", "PC-242", "PC-243", "PC-244", "AG-248", "AG-247", "AG-246", "AG-245", "BL-257", "BL-258", "BL-259", "BL-260", "BL-261", "BL-262", "BL-263", "BL-264", "BL-265", "BL-266", "BL-267", "BL-268"]
    },
    {
      product: "Languo Pro Acrylic Brush Marker Set (M730)  – 192 Colours",
      variant: null,
      variantId: null,
      handle: "languo-pro-acrylic-brush-marker-set-m730-192-colours",
      codes: ["GB-401", "GB-403", "PU-302", "PC-802", "PU-301", "HC-609", "BR-704", "GB-402", "PC-814", "YE-136", "PC-816", "CB-907", "DB-163", "DB-169", "RY-10", "BR-713", "BR-702", "GB-404", "PU-304", "HC-139", "LC-116", "HC-131", "CS-149", "GR-102", "LC-117", "HC-606", "GB-407", "CB-910", "DB-164", "DB-167", "RY-12", "BR-714", "BR-706", "GB-405", "PU-305", "PU-308", "LC-118", "GR-107", "RY-08", "CB-901", "LC-115", "CS-511", "GB-411", "SG-159", "DB-165", "DB-168", "RY-11", "BR-715", "CB-906", "CB-902", "CB-908", "PC-807", "LC-112", "CB-903", "BR-709", "PC-806", "HC-601", "YE-135", "CS-148", "SG-158", "GR-114", "BL-214", "RY-13", "BR-708", "RY-09", "GR-109", "BL-209", "PU-306", "LC-114", "BL-207", "BR-707", "PU-303", "CS-146", "YE-134", "BR-703", "SG-157", "DB-166", "BL-213", "RY-14", "GB-412", "RY-07", "GR-108", "BL-208", "CS-509", "LC-113", "PC-809", "GB-406", "PU-307", "PC-801", "YE-123", "BR-711", "SG-154", "GR-115", "BL-212", "PC-808", "PU-315", "RY-06", "GR-106", "BL-206", "CS-508", "RY-04", "CB-904", "HC-135", "PC-804", "PC-810", "HC-602", "GB-408", "GR-112", "GR-113", "BL-211", "PC-815", "PU-314", "RY-05", "GR-105", "BL-205", "CS-507", "YE-125", "CB-909", "YE-128", "HC-607", "PU-310", "YE-132", "BR-712", "GR-111", "SG-156", "BL-210", "PC-813", "HC-605", "YE-126", "GR-104", "BL-204", "CS-506", "YE-127", "CB-905", "YE-124", "HC-136", "CS-144", "YE-130", "GB-409", "HC-132", "SG-155", "HC-604", "PC-812", "PU-312", "RY-03", "HC-603", "BL-203", "CS-143", "HC-608", "PC-805", "YE-122", "CS-147", "CS-502", "YE-131", "GB-410", "HC-133", "SG-153", "HC-138", "PC-803", "HC-137", "RY-02", "GR-103", "BL-202", "CS-503", "YE-129", "LC-119", "YE-121", "LC-111", "CS-505", "CS-510", "CS-504", "YE-133", "SG-152", "DB-162", "PC-811", "PU-313", "RY-01", "GR-101", "BL-201", "CS-501", "HC-134", "BR-705", "CS-141", "CS-145", "BR-701", "CS-142", "BR-710", "GR-110", "SG-151", "DB-161", "PU-309", "PU-311."]
    },
    {
      product: "Languo Pro Acrylic Brush Marker Set (M730) - 96 Colours",
      variant: null,
      variantId: null,
      handle: "languo-pro-acrylic-brush-marker-set-m730-96-colours",
      codes: ["RY-01", "RY-02", "RY-03", "YE-126", "RY-05", "RY-06", "RY-07", "RY-09", "CB-906", "BR-706", "GR-101", "GR-103", "HC-603", "GR-104", "GR-105", "GR-106", "GR-108", "GR-109", "CB-902", "GB-405", "BL-201", "BL-202", "BL-203", "BL-204", "BL-205", "BL-206", "BL-208", "BL-209", "CB-908", "PU-305", "CS-501", "CS-503", "CS-143", "CS-506", "CS-507", "CS-508", "CS-509", "PU-306", "PC-807", "PU-308", "HC-134", "YE-129", "HC-608", "YE-127", "YE-125", "RY-04", "LC-113", "LC-114", "LC-112", "LC-118", "BR-705", "LC-119", "PC-805", "CB-905", "CB-909", "CB-904", "PC-809", "BL-207", "CB-903", "GR-107", "CS-141", "YE-121", "YE-122", "YE-124", "YE-128", "HC-135", "GB-406", "BR-707", "BR-709", "RY-08", "CS-145", "LC-111", "CS-147", "HC-136", "HC-607", "PC-804", "PU-307", "PU-303", "PC-806", "CB-901", "BR-702", "GB-401", "GB-404", "GB-403", "PU-304", "PU-302", "HC-139", "PC-802", "LC-116", "PU-301", "HC-131", "HC-609", "CS-149", "BR-704", "GR-102", "GB-402."]
    },
    {
      product: "Languo Pro Acrylic Brush Marker Set (M730) – 48 Colours",
      variant: null,
      variantId: null,
      handle: "languo-pro-acrylic-brush-marker-set-m730-48-colours",
      codes: ["RY-01", "RY-02", "RY-03", "YE-126", "RY-05", "RY-06", "RY-07", "RY-09", "GR-101", "GR-103", "HC-603", "GR-104", "GR-105", "GR-106", "GR-108", "GR-109", "BL-201", "BL-202", "BL-203", "BL-204", "BL-205", "BL-206", "BL-208", "BL-209", "CS-501", "CS-503", "CS-143", "CS-506", "CS-507", "CS-508", "CS-509", "PU-306", "CB-906", "BR-706", "BR-702", "GB-401", "CB-902", "GB-405", "GB-404", "GB-403", "CB-908", "PU-305", "PU-304", "PU-302", "PC-807", "PU-308", "HC-139", "PC-802"]
    },
    {
      product: "Languo Pro Acrylic Brush Marker Set (M730) – 72 Colours",
      variant: null,
      variantId: null,
      handle: "languo-pro-acrylic-brush-marker-set-m730-72-colours",
      codes: ["RY-01", "RY-02", "RY-03", "YE-126", "RY-05", "RY-06", "RY-07", "RY-09", "CB-906", "GR-101", "GR-103", "HC-603", "GR-104", "GR-105", "GR-106", "GR-108", "GR-109", "CB-902", "BL-201", "BL-202", "BL-203", "BL-204", "BL-205", "BL-206", "BL-208", "BL-209", "CB-908", "CS-501", "CS-503", "CS-143", "CS-506", "CS-507", "CS-508", "CS-509", "PU-306", "PC-807", "HC-134", "YE-129", "HC-608", "YE-127", "YE-125", "RY-04", "LC-113", "LC-114", "LC-112", "BR-705", "LC-119", "PC-805", "CB-905", "CB-909", "CB-904", "PC-809", "BL-207", "CB-903", "BR-706", "BR-702", "GB-401", "GB-405", "GB-404", "GB-403", "PU-305", "PU-304", "PU-302", "PU-308", "HC-139", "PC-802", "LC-118", "LC-116", "PU-301", "GR-107", "HC-131", "HC-609."]
    },
    {
      product: "Guangna High Gloss - 168 Pen Set",
      variant: null,
      variantId: null,
      handle: "guangna-high-gloss-168-pen-set",
      codes: ["Y01", "Y02", "Y03", "Y04", "Y05", "Y06", "Y07", "Y08", "Y09", "Y10", "Y11", "Y12", "Y13", "Y14", "Y15", "Y16", "Y17", "R01", "R02", "R03", "R04", "R05", "R06", "R07", "R08", "R09", "R10", "R11", "R12", "R13", "F01", "F02", "F03", "F04", "F05", "F06", "F07", "F08", "F09", "F10", "F11", "F12", "F13", "F14", "F15", "F16", "F17", "F18", "F19", "F20", "F21", "F22", "F23", "F24", "F25", "F26", "F27", "F28", "F29", "F30", "F31", "F32", "F33", "F34", "F35", "F36", "F37", "P01", "P02", "P03", "P04", "P05", "P06", "P07", "P08", "P09", "P10", "P11", "P12", "P13", "P14", "Z01", "Z02", "Z03", "Z04", "Z05", "Z06", "Z07", "Z08", "Z09", "Z10", "Z11", "Z12", "Z13", "Z14", "Z15", "Z16", "L01", "L02", "L03", "L04", "L05", "L06", "L07", "L08", "L09", "L10", "L11", "L12", "L13", "L14", "L15", "L16", "L17", "L18", "L19", "L20", "L21", "L22", "L23", "L24", "L25", "L26", "L27", "G01", "G02", "G03", "G04", "G05", "G06", "G07", "G08", "G09", "G10", "G11", "G12", "G13", "G14", "G15", "G16", "G17", "G18", "G19", "G20", "G21", "G22", "G23", "G24", "G25", "G26", "G27", "G28", "G29", "G30", "G31", "G32", "G33", "G34", "G35", "G36", "G37", "G38", "G39", "G40", "G41", "H01", "H02 and H03."]
    },
    {
      product: "Guangna High Gloss - 72 Pen Set",
      variant: null,
      variantId: null,
      handle: "guangna-high-gloss-72-pen-set",
      codes: ["F13", "F02", "Y02", "F08", "R02", "R05", "P02", "P07", "Z01", "F18", "F04", "F17", "F29", "R03", "R07", "P03", "P10", "Z02", "F11", "F07", "Y03", "F31", "R04", "R34", "P05", "P11", "Z04", "F12", "F24", "Y06", "F09", "Y12", "R13", "F35", "Z10", "Z11", "Z05", "L07", "L01", "L15", "L20", "G01", "G07", "G14", "G20", "Z06", "L08", "L02", "L14", "L23", "G03", "G08", "G16", "G21", "Z07", "L11", "L03", "L13", "L24", "G04", "G10", "G17", "G36", "Z08", "L12", "L04", "H01", "L18", "G05", "G11", "G12 and H02."]
    },
    {
      product: "36 Colour Retractable Gel Pen Set – 0.7mm",
      variant: null,
      variantId: null,
      handle: "lg-07-click-set-36",
      codes: ["BG-902", "BG-903", "BG-904", "BG-906", "BG-907", "BG-909", "BG-801", "BG-803", "BG-804", "BG-805", "BG-807", "BG-809", "BG-701", "BG-702", "BG-704", "BG-705", "BG-707", "BG-709", "BG-501", "BG-502", "BG-503", "BG-505", "BG-506", "BG-508", "BG-601", "BG-602", "BG-603", "BG-604", "BG-606", "BG-609", "BG-111", "BG-112", "BG-113", "BG-114", "BG-116 and BG-117."]
    },
    {
      product: "72 Colour Retractable Gel Pen Set – 0.7mm",
      variant: null,
      variantId: null,
      handle: "lg-07-click-set-72",
      codes: ["BG-902", "BG-903", "BG-904", "BG-906", "BG-907", "BG-909", "BG-801", "BG-803", "BG-804", "BG-805", "BG-807", "BG-809", "BG-701", "BG-702", "BG-704", "BG-705", "BG-707", "BG-709", "BG-501", "BG-502", "BG-503", "BG-505", "BG-506", "BG-508", "BG-601", "BG-602", "BG-603", "BG-604", "BG-606", "BG-609", "BG-111", "BG-112", "BG-113", "BG-114", "BG-116", "BG-117", "BG-121", "BG-122", "BG-124", "BG-125", "BG-126", "BG-128", "BG-161", "BG-162", "BG-164", "BG-166", "BG-167", "BG-169", "BG-132", "BG-133", "BG-135", "BG-136", "BG-137", "BG-139", "BG-171", "BG-173", "BG-175", "BG-176", "BG-177", "BG-178", "BG-181", "BG-183", "BG-184", "BG-185", "BG-187", "BG-189", "BG-151", "BG-152", "BG-154", "BG-155", "BG-157 and BG-158."]
    },
    {
      product: "Languo Retractable 0.7mm Acrylic Gel Pen - 90 Set",
      variant: null,
      variantId: null,
      handle: "languo-retractable-0-7mm-acrylic-gel-pen-90-set",
      codes: ["BG-902", "BG-903", "BG-904", "BG-906", "BG-907", "BG-909", "BG-801", "BG-803", "BG-804", "BG-805", "BG-807", "BG-809", "BG-701", "BG-702", "BG-704", "BG-705", "BG-707", "BG-709", "BG-501", "BG-502", "BG-503", "BG-505", "BG-506", "BG-508", "BG-601", "BG-602", "BG-603", "BG-604", "BG-606", "BG-609", "BG-111", "BG-112", "BG-113", "BG-114", "BG-116", "BG-117", "BG-121", "BG-122", "BG-124", "BG-125", "BG-126", "BG-128", "BG-161", "BG-162", "BG-164", "BG-166", "BG-167", "BG-169", "BG-132", "BG-133", "BG-135", "BG-136", "BG-137", "BG-139", "BG-171", "BG-173", "BG-175", "BG-176", "BG-177", "BG-178", "BG-181", "BG-183", "BG-184", "BG-185", "BG-187", "BG-189", "BG-151", "BG-152", "BG-154", "BG-155", "BG-157", "BG-158", "BG-191", "BG-192", "BG-193", "BG-196", "BG-197", "BG-199", "BG-03", "BG-204", "BG-203", "BG-304", "BG-303", "BG-104", "BG-02", "BG-202", "BG-102", "BG-201", "BG-301 and BG-101."]
    },
    {
      product: "Languo Retractable 0.7mm Acrylic Gel Pen 54 Set",
      variant: null,
      variantId: null,
      handle: "languo-retractable-0-7mm-acrylic-gel-pen-54-set",
      codes: ["BG-902", "BG-903", "BG-904", "BG-906", "BG-907", "BG-909", "BG-801", "BG-803", "BG-804", "BG-805", "BG-807", "BG-809", "BG-701", "BG-702", "BG-704", "BG-705", "BG-707", "BG-709", "BG-501", "BG-502", "BG-503", "BG-505", "BG-506", "BG-508", "BG-601", "BG-602", "BG-603", "BG-604", "BG-606", "BG-609", "BG-111", "BG-112", "BG-113", "BG-114", "BG-116", "BG-117", "BG-121", "BG-122", "BG-124", "BG-125", "BG-126", "BG-128", "BG-161", "BG-162", "BG-164", "BG-166", "BG-167", "BG-169", "BG-132", "BG-133", "BG-135", "BG-136", "BG-137 and BG-139."]
    },
    {
      product: "Languo 1mm - 72 Colour Super Shiny Plus Gel Pen Set",
      variant: null,
      variantId: null,
      handle: "languo-1mm-72-colour-super-shiny-plus-gel-pen-set",
      codes: ["SG-01", "SG-02", "SG-03", "SG-04", "SG-05", "SG-06", "SG-81", "SG-82", "SG-83", "SG-84", "SG-85", "SG-86", "SG-111", "SG-112", "SG-113", "SG-114", "SG-115", "SG-116", "SG-71", "SG-72", "SG-73", "SG-74", "SG-75", "SG-76", "SG-61", "SG-62", "SG-63", "SG-64", "SG-65", "SG-66", "SG-51", "SG-52", "SG-53", "SG-54", "SG-55", "SG-56", "SG-41", "SG-42", "SG-43", "SG-44", "SG-45", "SG-46", "SG-101", "SG-102", "SG-103", "SG-104", "SG-105", "SG-106", "SG-21", "SG-22", "SG-23", "SG-24", "SG-25", "SG-26", "SG-91", "SG-92", "SG-93", "SG-94", "SG-95", "SG-96", "SG-11", "SG-12", "SG-13", "SG-14", "SG-15", "SG-16", "SG-31", "SG-32", "SG-33", "SG-34", "SG-35 and SG-36."]
    },
    {
      product: "Guangna - 12 Black Acrylic Brush Markers",
      variant: null,
      variantId: null,
      handle: "guangna-12-black-acrylic-brush-markers",
      codes: ["BLACK"]
    },
    {
      product: "Guangna 12 Acrylic Brush Markers",
      variant: null,
      variantId: null,
      handle: "guangna-12-acrylic-brush-markers",
      codes: ["603", "604", "606", "605", "614", "609", "601", "608", "620", "607", "600 and 611."]
    },
    {
      product: "Guangna 12 Dual Tip Acrylic Brush Markers (Green Tones)",
      variant: null,
      variantId: null,
      handle: "guangna-12-dual-tip-acrylic-brush-markers-green-tones",
      codes: ["700", "648", "727", "669", "614", "668", "657", "687", "728", "740", "634 and 794."]
    },
    {
      product: "Guangna 24 Acrylic Brush Markers - Macaron Colours Set",
      variant: null,
      variantId: null,
      handle: "guangna-24-acrylic-brush-markers-macaron-colours-set",
      codes: ["736", "732", "723", "702", "700", "628", "627", "730", "706", "729", "738", "646", "737", "648", "704", "744", "733", "717", "669", "745", "635", "649", "655", "822"]
    },
    {
      product: "Guangna 24 Acrylic Brush Markers - Skin Tones Set",
      variant: null,
      variantId: null,
      handle: "guangna-24-acrylic-brush-markers-skin-tones-set",
      codes: ["626", "683", "724", "718", "719", "701", "720", "717", "656", "684", "654", "618", "644", "639", "672", "723", "658", "721", "703", "624", "716", "625", "723", "704", "667"]
    },
    {
      product: "Guangna 240 Acrylic Brush Marker Set",
      variant: null,
      variantId: null,
      handle: "guangna-240-acrylic-brush-marker-set",
      codes: ["691", "667", "605", "674", "664", "781", "872", "716", "677", "692", "761", "711", "710", "713", "714", "715", "760", "836", "723", "873", "658", "655", "612", "606", "666", "671", "726", "719", "701", "720", "702", "649", "604", "725", "631", "785", "724", "683", "656", "684", "802", "786", "618", "766", "732", "733", "777", "765", "603", "615", "663", "783", "782", "632", "784", "630", "754", "755", "756", "619", "869", "672", "780", "772", "739", "675", "705", "738", "752", "771", "770", "769", "779", "808", "776", "717", "654", "644", "639", "620", "679", "759", "708", "709", "646", "638", "751", "753", "645", "731", "757", "758", "643", "642", "633", "750", "747", "693", "806", "763", "600", "801", "803", "804", "853", "686", "610", "805", "680", "807", "611", "855", "856", "662", "859", "661", "854", "712", "762", "660", "730", "700", "648", "727", "647", "657", "687", "665", "740", "634", "676", "794", "796", "795", "809", "627", "685", "735", "669", "614", "668", "728", "609", "800", "797", "707", "775", "696", "641", "741", "682", "792", "697", "791", "626", "729", "652", "787", "640", "637", "788", "793", "790", "789", "810", "811", "812", "813", "814", "815", "817", "816", "737", "602", "653", "722", "799", "690", "622", "695", "768", "767", "748", "694", "818", "819", "820", "823", "616", "798", "636", "774", "688", "706", "821", "628", "822", "601", "650", "621", "659", "617", "746", "824", "608", "673", "736", "689", "681", "749", "745", "670", "825", "826", "773", "827", "734", "744", "698", "635", "623", "699", "833", "832", "613", "778", "629", "651", "828", "742", "743", "607", "678", "764", "837", "721", "703", "624", "625", "704"]
    },
    {
      product: "Guangna 30 Dual Tip Acrylic Brush Markers Set",
      variant: null,
      variantId: null,
      handle: "guangna-30-dual-tip-acrylic-brush-markers",
      codes: ["648", "735", "687", "665", "652", "787", "741", "682", "676", "794", "796", "795", "818", "819", "602", "799", "821", "822", "601", "650", "659", "608", "745", "670", "734", "744", "833", "832", "743", "607", "673", "678", "872", "873", "704", "691", "655", "712", "606", "666", "664", "781", "732", "733", "656", "802", "702", "649", "777", "786", "725", "782", "618", "784", "672", "780", "686", "680", "600 and 611."]
    },
    {
      product: "Guangna 48 Acrylic Brush Markers Set",
      variant: null,
      variantId: null,
      handle: "guangna-48-acrylic-brush-markers-set",
      codes: ["627", "602", "646", "684", "626", "649", "654", "605", "624", "635", "629", "628", "681", "614", "609", "652", "618", "656", "604", "619", "664", "658", "623", "651", "601", "600", "668", "622", "603", "663", "672", "612", "613", "607", "650", "610", "665", "615", "620", "655", "616", "611", "634", "606", "617", "671", "608 and 673."]
    },
    {
      product: "Guangna 60 Acrylic Brush Markers Set",
      variant: null,
      variantId: null,
      handle: "guangna-60-acrylic-brush-markers-set",
      codes: ["627", "648", "646", "683", "626", "625", "630", "667", "624", "635", "629", "628", "681", "614", "669", "645", "684", "656", "649", "654", "605", "658", "623", "670", "601", "600", "668", "665", "652", "618", "603", "604", "619", "664", "612", "613", "651", "650", "686", "602", "634", "637", "643", "615", "663", "672", "607", "616", "610", "609", "676", "620", "606", "671", "617", "608", "611", "622 and 673."]
    },
    {
      product: "Languo x Qimiart Erasable Gel Pens",
      variant: "45 Pc Set",
      variantId: "60076687655296",
      handle: "languo-x-qimiart-erasable-gel-pens",
      codes: ["KC-001", "KC-002", "KC-003", "KC-004", "KC-005", "KC-006", "KC-007", "KC-008", "KC-009", "KC-010", "KC-011", "KC-012", "KC-013", "KC-014", "KC-015", "KC-016", "KC-017", "KC-018", "KC-019", "KC-020", "KC-033", "KC-022", "KC-023", "KC-024", "KC-047", "KC-026", "KC-027", "KC-028", "KC-029", "KC-030", "KC-031", "KC-032", "KC-037", "KC-034", "KC-046", "KC-036", "KC-021", "KC-038", "KC-039", "KC-040", "KC-035", "KC-042", "KC-043", "KC-044", "KC-045"]
    },
    {
      product: "Languo x Qimiart Erasable Gel Pens",
      variant: "Candy Colours",
      variantId: "60076687491456",
      handle: "languo-x-qimiart-erasable-gel-pens",
      codes: ["KC-028", "KC-029", "KC-030", "KC-031", "KC-032", "KC-037", "KC-034", "KC-046", "KC-036"]
    },
    {
      product: "Languo x Qimiart Erasable Gel Pens",
      variant: "Macaron Colours",
      variantId: "60076687524224",
      handle: "languo-x-qimiart-erasable-gel-pens",
      codes: ["KC-021", "KC-038", "KC-039", "KC-040", "KC-035", "KC-042", "KC-043", "KC-044", "KC-045"]
    },
    {
      product: "Languo x Qimiart Erasable Gel Pens",
      variant: "Morandi Colours",
      variantId: "60076687556992",
      handle: "languo-x-qimiart-erasable-gel-pens",
      codes: ["KC-010", "KC-011", "KC-012", "KC-013", "KC-014", "KC-015", "KC-016", "KC-017", "KC-018"]
    },
    {
      product: "Languo x Qimiart Erasable Gel Pens",
      variant: "Rainbow Colours",
      variantId: "60076687589760",
      handle: "languo-x-qimiart-erasable-gel-pens",
      codes: ["KC-019", "KC-020", "KC-033", "KC-022", "KC-023", "KC-024", "KC-047", "KC-026", "KC-027"]
    },
    {
      product: "Languo x Qimiart Erasable Gel Pens",
      variant: "Retro Colours",
      variantId: "60076687622528",
      handle: "languo-x-qimiart-erasable-gel-pens",
      codes: ["KC-001", "KC-002", "KC-003", "KC-004", "KC-005", "KC-006", "KC-007", "KC-008", "KC-009"]
    },
    {
      product: "Flysea Acrylic Brush Markers Assorted Colours (24 pack)",
      variant: null,
      variantId: null,
      handle: "flysea-acrylic-brush-markers-assorted-colours-24-pack-2",
      codes: ["600", "601", "602", "603", "604", "605", "606", "607", "608", "609", "611", "612", "613", "614", "615", "616", "617", "618", "619", "620", "622", "623", "634", "655"]
    }
  ];

  newProducts.forEach(function (product) {
    product.codes.forEach(function (code) {
      if (!window.FLC_PEN_FINDER_VARIANT_DATA[code]) {
        window.FLC_PEN_FINDER_VARIANT_DATA[code] = [];
      }

      var entry = {
        code: code,
        name: product.variant
          ? product.product + " – " + product.variant + " Variant"
          : product.product,
        handle: product.handle
      };

      if (product.variantId) {
        entry.variantId = product.variantId;
        entry.variant = product.variant;
      }

      window.FLC_PEN_FINDER_VARIANT_DATA[code].push(entry);
    });
  });
})();

 // ==========================================================
// FIND MY PEN: LANGUO PLUS 1mm INDIVIDUAL PENS - PICK & MIX
// Corrected from the latest spreadsheet: 144 variant rows.
// Keep the rest of pen-finder-variant-data-v1.js unchanged.
// ==========================================================

(function () {
  var newProducts = [
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-02", "variantId": "60139751473536", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-02"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-03", "variantId": "60139751276928", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-03"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-101", "variantId": "60139751637376", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-101"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-102", "variantId": "60139751539072", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-102"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-104", "variantId": "60139751440768", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-104"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-111", "variantId": "60139749704064", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-111"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-112", "variantId": "60139749736832", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-112"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-113", "variantId": "60139749769600", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-113"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-114", "variantId": "60139749802368", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-114"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-116", "variantId": "60139749835136", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-116"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-117", "variantId": "60139749867904", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-117"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-121", "variantId": "60139749900672", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-121"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-122", "variantId": "60139749933440", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-122"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-124", "variantId": "60139749966208", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-124"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-125", "variantId": "60139749998976", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-125"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-126", "variantId": "60139750031744", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-126"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-128", "variantId": "60139750064512", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-128"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-132", "variantId": "60139750293888", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-132"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-133", "variantId": "60139750326656", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-133"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-135", "variantId": "60139750359424", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-135"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-136", "variantId": "60139750392192", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-136"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-137", "variantId": "60139750424960", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-137"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-139", "variantId": "60139750457728", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-139"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-151", "variantId": "60139750883712", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-151"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-152", "variantId": "60139750916480", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-152"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-154", "variantId": "60139750949248", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-154"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-155", "variantId": "60139750982016", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-155"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-157", "variantId": "60139751014784", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-157"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-158", "variantId": "60139751047552", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-158"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-161", "variantId": "60139750097280", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-161"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-162", "variantId": "60139750130048", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-162"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variantId": "60139750162816", "variant": "BG-164", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-164"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-166", "variantId": "60139750195584", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-166"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-167", "variantId": "60139750228352", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-167"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-169", "variantId": "60139750261120", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-169"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-171", "variantId": "60139750490496", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-171"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-173", "variantId": "60139750523264", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-173"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-175", "variantId": "60139750556032", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-175"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-176", "variantId": "60139750588800", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-176"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-177", "variantId": "60139750621568", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-177"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-178", "variantId": "60139750654336", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-178"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-181", "variantId": "60139750687104", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-181"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-183", "variantId": "60139750719872", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-183"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-184", "variantId": "60139750752640", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-184"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-185", "variantId": "60139750785408", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-185"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-187", "variantId": "60139750818176", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-187"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-189", "variantId": "60139750850944", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-189"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-191", "variantId": "60139751080320", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-191"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-192", "variantId": "60139751113088", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-192"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-193", "variantId": "60139751145856", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-193"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-196", "variantId": "60139751178624", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-196"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-197", "variantId": "60139751211392", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-197"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-199", "variantId": "60139751244160", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-199"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-201 (A)", "variantId": "60139751571840", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-201"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-201 (B)", "variantId": "60139751866752", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-201"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-202 (A)", "variantId": "60139751506304", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-202"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-202 (B)", "variantId": "60139751899520", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-202"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-203 (A)", "variantId": "60139751342464", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-203"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-203 (B)", "variantId": "60139751932288", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-203"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-204", "variantId": "60139751309696", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-204"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-205", "variantId": "60139751965056", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-205"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-206", "variantId": "60139751997824", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-206"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-209", "variantId": "60139752030592", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-209"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-211", "variantId": "60139752063360", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-211"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-213", "variantId": "60139752096128", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-213"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-214", "variantId": "60139752128896", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-214"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-215", "variantId": "60139752161664", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-215"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-217", "variantId": "60139752194432", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-217"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-219", "variantId": "60139752227200", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-219"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-221", "variantId": "60139752259968", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-221"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-222", "variantId": "60139752292736", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-222"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-225", "variantId": "60139752325504", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-225"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-226", "variantId": "60139752358272", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-226"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-227", "variantId": "60139752391040", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-227"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-229", "variantId": "60139752423808", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-229"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-232", "variantId": "60139752456576", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-232"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-233", "variantId": "60139752489344", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-233"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-234", "variantId": "60139752522112", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-234"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-236", "variantId": "60139752554880", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-236"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-237", "variantId": "60139752587648", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-237"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-238", "variantId": "60139752620416", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-238"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-241", "variantId": "60139752653184", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-241"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-242", "variantId": "60139752685952", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-242"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-243", "variantId": "60139752718720", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-243"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-245", "variantId": "60139752751488", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-245"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-248", "variantId": "60139752784256", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-248"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-249", "variantId": "60139752817024", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-249"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-251", "variantId": "60139752849792", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-251"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-252", "variantId": "60139752882560", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-252"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-256", "variantId": "60139752915328", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-256"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-257", "variantId": "60139752948096", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-257"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-258", "variantId": "60139752980864", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-258"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-259", "variantId": "60139753013632", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-259"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-261", "variantId": "60139753046400", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-261"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-262", "variantId": "60139753079168", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-262"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-263", "variantId": "60139753111936", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-263"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-265", "variantId": "60139753144704", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-265"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-267", "variantId": "60139753177472", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-267"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-269", "variantId": "60139753210240", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-269"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-271", "variantId": "60139753243008", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-271"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-272", "variantId": "60139753275776", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-272"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-273", "variantId": "60139753308544", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-273"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-275", "variantId": "60139753341312", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-275"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-276", "variantId": "60139753374080", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-276"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-278", "variantId": "60139753406848", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-278"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-301", "variantId": "60139751604608", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-301"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-303", "variantId": "60139751408000", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-303"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-304", "variantId": "60139751375232", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-304"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-402", "variantId": "60139751670144", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-402"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-403", "variantId": "60139751702912", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-403"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-404", "variantId": "60139751735680", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-404"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-405", "variantId": "60139751768448", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-405"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-407", "variantId": "60139751801216", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-407"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-409", "variantId": "60139751833984", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-409"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-501", "variantId": "60139749310848", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-501"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-502", "variantId": "60139749343616", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-502"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-503", "variantId": "60139749376384", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-503"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-505", "variantId": "60139749409152", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-505"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-506", "variantId": "60139749441920", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-506"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-508", "variantId": "60139749474688", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-508"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-601", "variantId": "60139749507456", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-601"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-602", "variantId": "60139749540224", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-602"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-603", "variantId": "60139749572992", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-603"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-604", "variantId": "60139749605760", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-604"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-606", "variantId": "60139749638528", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-606"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-609", "variantId": "60139749671296", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-609"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-701", "variantId": "60139749114240", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-701"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-702", "variantId": "60139749147008", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-702"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-704", "variantId": "60139749179776", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-704"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-705", "variantId": "60139749212544", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-705"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-707", "variantId": "60139749245312", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-707"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-709", "variantId": "60139749278080", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-709"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-801", "variantId": "60139748917632", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-801"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-803", "variantId": "60139748950400", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-803"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-804", "variantId": "60139748983168", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-804"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-805", "variantId": "60139749015936", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-805"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-807", "variantId": "60139749048704", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-807"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-809", "variantId": "60139749081472", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-809"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-902", "variantId": "60139748721024", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-902"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-903", "variantId": "60139748753792", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-903"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-904", "variantId": "60139748786560", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-904"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-906", "variantId": "60139748819328", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-906"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-907", "variantId": "60139748852096", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-907"]},
    {"product": "Languo Plus 1mm - Individual Pens - Pick & Mix Pens", "variant": "BG-909", "variantId": "60139748884864", "handle": "languo-plus-1mm-individual-pens-pick-mix-pens", "codes": ["BG-909"]}
  ];

  newProducts.forEach(function (product) {
    product.codes.forEach(function (code) {
      if (!window.FLC_PEN_FINDER_VARIANT_DATA[code]) {
        window.FLC_PEN_FINDER_VARIANT_DATA[code] = [];
      }

      var entry = {
        code: code,
        name: product.product + " – " + product.variant + " Variant",
        handle: product.handle
      };

      if (product.variantId) {
        entry.variantId = product.variantId;
        entry.variant = product.variant;
      }

      window.FLC_PEN_FINDER_VARIANT_DATA[code].push(entry);
    });
  });
})();

// FOXFEEL ACRYLIC BRUSH MARKERS - 12 COLOUR SETS
(function () {
  var newProducts = [
    {
      product: "Foxfeel Acrylic Brush Markers – 12 Colour Sets",
      variant: "Blue Tones 12pc",
      variantId: "60219285799296",
      handle: "foxfeel-acrylic-12-24pc",
      codes: ["311", "341", "245", "389", "331", "260", "329", "310", "281", "393", "309", "323"]
    },
    {
      product: "Foxfeel Acrylic Brush Markers – 12 Colour Sets",
      variant: "Gray Tones 12pc",
      variantId: "60219285733760",
      handle: "foxfeel-acrylic-12-24pc",
      codes: ["336", "441", "335", "337", "324", "394", "320", "277", "319", "385", "387", "348"]
    },
    {
      product: "Foxfeel Acrylic Brush Markers – 12 Colour Sets",
      variant: "Green Tones 12pc",
      variantId: "60219285930368",
      handle: "foxfeel-acrylic-12-24pc",
      codes: ["271", "351", "272", "248", "280", "396", "264", "314", "313", "350", "312", "315"]
    },
    {
      product: "Foxfeel Acrylic Brush Markers – 12 Colour Sets",
      variant: "Macaron 12pc",
      variantId: "60219285766528",
      handle: "foxfeel-acrylic-12-24pc",
      codes: ["246", "289", "304", "356", "249", "384", "299", "313", "248", "389", "309", "336"]
    },
    {
      product: "Foxfeel Acrylic Brush Markers – 12 Colour Sets",
      variant: "Orange Tones 12pc",
      variantId: "60219285995904",
      handle: "foxfeel-acrylic-12-24pc",
      codes: ["360", "253", "302", "303", "326", "295", "237", "285", "417", "159", "160", "118"]
    },
    {
      product: "Foxfeel Acrylic Brush Markers – 12 Colour Sets",
      variant: "Purple Tomes 12pc",
      variantId: "60219285832064",
      handle: "foxfeel-acrylic-12-24pc",
      codes: ["391", "384", "307", "395", "308", "386", "356", "327", "383", "346", "368", "332"]
    },
    {
      product: "Foxfeel Acrylic Brush Markers – 12 Colour Sets",
      variant: "Red Tones 12pc",
      variantId: "60219285897600",
      handle: "foxfeel-acrylic-12-24pc",
      codes: ["326", "230", "176", "304", "316", "306", "338", "378", "333", "377", "305", "322"]
    },
    {
      product: "Foxfeel Acrylic Brush Markers – 12 Colour Sets",
      variant: "Reddish Brown 12pc",
      variantId: "60219285963136",
      handle: "foxfeel-acrylic-12-24pc",
      codes: ["353", "142", "333", "318", "388", "366", "370", "365", "334", "348", "290", "317"]
    },
    {
      product: "Foxfeel Acrylic Brush Markers – 12 Colour Sets",
      variant: "Skin Tone 12pc",
      variantId: "60219285864832",
      handle: "foxfeel-acrylic-12-24pc",
      codes: ["289", "367", "302", "390", "370", "363", "321", "333", "364", "365", "388", "290"]
    },
    {
      product: "Foxfeel Acrylic Brush Markers – 12 Colour Sets",
      variant: "Yellow Tones 12pc",
      variantId: "60219286028672",
      handle: "foxfeel-acrylic-12-24pc",
      codes: ["357", "224", "364", "220", "369", "301", "300", "374", "406", "367", "392", "325"]
    }
  ];

  newProducts.forEach(function (product) {
    product.codes.forEach(function (code) {
      if (!window.FLC_PEN_FINDER_VARIANT_DATA[code]) {
        window.FLC_PEN_FINDER_VARIANT_DATA[code] = [];
      }

      window.FLC_PEN_FINDER_VARIANT_DATA[code].push({
        code: code,
        name: product.product + " – " + product.variant + " Variant",
        handle: product.handle,
        variantId: product.variantId,
        variant: product.variant
      });
    });
  });
})();

// FOXFEEL ACRYLIC BRUSH MARKERS - 24 COLOUR SETS
(function () {
  var newProducts = [
    {
      product: "Foxfeel Acrylic Brush Markers – 24 Colour Sets",
      variant: "Macaron Tones 24pc",
      variantId: "60292353163648",
      handle: "foxfeel-acrylic-brush-markers-24-colour-sets",
      codes: [
        "321", "336", "246", "280", "378", "384", "341", "395",
        "312", "289", "202", "248", "363", "313", "389", "304",
        "368", "299", "249", "274", "305", "309", "356", "357"
      ]
    },
    {
      product: "Foxfeel Acrylic Brush Markers – 24 Colour Sets",
      variant: "Purple Tones 24 pc",
      variantId: "60292436427136",
      handle: "foxfeel-acrylic-brush-markers-24-colour-sets",
      codes: [
        "416", "380", "356", "307", "460", "254", "368", "327",
        "346", "185", "395", "383", "332", "171", "135", "150",
        "257", "308", "193", "391", "384", "386", "250", "296"
      ]
    },
    {
      product: "Foxfeel Acrylic Brush Markers – 24 Colour Sets",
      variant: "Skin Tones 24 pc",
      variantId: "60292436459904",
      handle: "foxfeel-acrylic-brush-markers-24-colour-sets",
      codes: [
        "321", "142", "367", "334", "362", "289", "357", "105",
        "364", "333", "388", "353", "433", "247", "390", "302",
        "370", "363", "343", "299", "365", "304", "258", "290"
      ]
    }
  ];

  newProducts.forEach(function (product) {
    product.codes.forEach(function (code) {
      if (!window.FLC_PEN_FINDER_VARIANT_DATA[code]) {
        window.FLC_PEN_FINDER_VARIANT_DATA[code] = [];
      }

      window.FLC_PEN_FINDER_VARIANT_DATA[code].push({
        code: code,
        name: product.product + " – " + product.variant + " Variant",
        handle: product.handle,
        variantId: product.variantId,
        variant: product.variant
      });
    });
  });
})();
